module.exports = {
  "messages": {
    "BUTTON_CANCEL": "Cancel",
    "BUTTON_FORWARD": "Next",
    "BUTTON_LESS": "Less",
    "BUTTON_MORE": "More",
    "BUTTON_SAVE": "Save",
    "BUTTON_SHOW_LESS": "Less",
    "BUTTON_SHOW_MORE": "Show more",
    "BUTTON_SUBMIT": "Submit",
    "COMPANY_BENEFIT_ACCESSIBILITY": "Accessibility",
    "COMPANY_BENEFIT_CANTEEN": "Canteen",
    "COMPANY_BENEFIT_CAR_PARK": "Car park",
    "COMPANY_BENEFIT_CHILDCARE": "Childcare",
    "COMPANY_BENEFIT_COMPANY_CAR": "Company car",
    "COMPANY_BENEFIT_COMPANY_DOCTOR": "Company doctor",
    "COMPANY_BENEFIT_COMPANY_PENSION": "Company pension",
    "COMPANY_BENEFIT_CONVENIENT_TRANSPORT_LINKS": "Convenient transport links",
    "COMPANY_BENEFIT_DISCOUNTS_SPECIAL_OFFERS": "Staff discounts",
    "COMPANY_BENEFIT_DOGS_WELCOME": "Dogs welcome",
    "COMPANY_BENEFIT_EVENTS_FOR_EMPLOYEES": "Staff events",
    "COMPANY_BENEFIT_FLEXITIME": "Flexitime",
    "COMPANY_BENEFIT_HEALTH_IN_THE_WORKPLACE": "Health benefits",
    "COMPANY_BENEFIT_HOME_OFFICE": "Work from home option",
    "COMPANY_BENEFIT_MOBILE_DEVICE": "Mobile device",
    "COMPANY_BENEFIT_PRIVATE_INTERNET_USE": "Private internet use",
    "COMPANY_BENEFIT_PROFIT_SHARING": "Profit-sharing",
    "COMPANY_BENEFIT_RESTAURANT_TICKETS": "Restaurant tickets",
    "COMPANY_BENEFIT_TRAINING": "Training",
    "COMPANY_DIRECTORY_LIST_H": "Companies starting with the letter",
    "COMPANY_DIRECTORY_META_DESCRIPTION": "Here you can see jobs at companies starting with the letter {letter} in XING Jobs.",
    "COMPANY_DIRECTORY_META_DESCRIPTION_OTHERS": "Here you'll find jobs at other companies on XING Jobs.",
    "COMPANY_DIRECTORY_OTHERS": "More",
    "COMPANY_DIRECTORY_SECTION_H": "Which company are you interested in?",
    "COMPANY_DIRECTORY_TITLE": "Search jobs by company name starting with {letter} | XING Jobs",
    "COMPANY_DIRECTORY_TITLE_OTHERS": "Search jobs at other companies | XING Jobs",
    "EMPLOYMENT_TYPE_STUDENT_LOCAL_SERPS": "Student jobs",
    "EP_EMPLOYEES": "employees",
    "EP_GO_STARTPAGE": "Go to XING homepage",
    "EP_KUNUNU_BENEFITS_TITLE": "Employee benefits",
    "JOBS_ALERTS_HEADER_MANAGE_ALERTS_BUTTON": "Manage search alerts",
    "JOBS_ALERTS_INTERVAL_DAILY": "Daily",
    "JOBS_ALERTS_INTERVAL_FEW_TIMES_A_DAY": "Several times per day",
    "JOBS_ALERTS_INTERVAL_NEVER": "Never",
    "JOBS_ALERTS_INTERVAL_WEEKLY": "Weekly",
    "JOBS_COMPANY_INSIGHTS_BENEFITS_LINK": "Find out more about benefits",
    "JOBS_COMPANY_INSIGHTS_COMPANY_JOBS": "Other vacancies",
    "JOBS_COMPANY_INSIGHTS_COMPANY_PROFILE": "View employer profile",
    "JOBS_COMPANY_INSIGHTS_EMPLOYER_REVIEWS": "Employer reviews on kununu",
    "JOBS_COMPANY_INSIGHTS_MODULE_FOLLOW": "Follow",
    "JOBS_COMPANY_INSIGHTS_MODULE_UNFOLLOW": "Unfollow",
    "JOBS_COMPANY_JOB_LOCATION": "Job location",
    "JOBS_COMPANY_LOCATION_MAP": "Show job location on map",
    "JOBS_CREATE_SEARCH_ALERT_LIGHTBOX_EMAIL_INPUT_LABEL": "E-mail address",
    "JOBS_CREATE_SEARCH_ALERT_LIGHTBOX_FREQUENCY_PARAGRAPH": "Select how often you'd like to receive search alert notifications: <a href=\"{link}\">Register now</a>",
    "JOBS_CREATE_SEARCH_ALERT_LIGHTBOX_PARAGRAPH": "Get e-mail notifications about jobs like this by creating a search alert:",
    "JOBS_CREATE_SEARCH_ALERT_LIGHTBOX_SUBSCRIPTION_CONFIRM": "We'll e-mail you a link to confirm and activate your new search alert.",
    "JOBS_DEFAULT_ERROR_MESSAGE": "Something went wrong. Please try again.",
    "JOBS_DETAIL_BACK_TO_JOB": "Back to job ad",
    "JOBS_DETAIL_COMPANY_CONTACTS_MODULE_SHOW_ALL": "Show all",
    "JOBS_DETAIL_COMPANY_CONTACTS_MODULE_SUBTITLE": "Find out by asking your contacts:",
    "JOBS_DETAIL_COMPANY_CONTACTS_MODULE_TITLE": "Good employer?",
    "JOBS_DETAIL_COMPANY_CONTACTS_PAGE_FIRST_DEGREE_CURRENT_TITLE": "Contacts currently working at {company}",
    "JOBS_DETAIL_COMPANY_CONTACTS_PAGE_FIRST_DEGREE_FORMER_TITLE": "Contacts who used to work there:",
    "JOBS_DETAIL_COMPANY_CONTACTS_PAGE_SECOND_DEGREE_TITLE": "Ask your contact to connect you with someone they know at {company}:",
    "JOBS_DETAIL_COMPANY_CONTACTS_PAGE_SUBTITLE": "How do you like your job and the company? Ask your contacts or request a referral.",
    "JOBS_DETAIL_COMPANY_CONTACTS_PAGE_TITLE": "Who you can contact at {company}",
    "JOBS_DETAIL_COMPANY_CONTACT_CONNECTION_HINT": "{name} is a shared contact.",
    "JOBS_DETAIL_COMPANY_CONTACT_CTA": "Start a chat",
    "JOBS_DETAIL_COMPANY_CONTACT_CURRENT_COMPANY": "Works at {company}",
    "JOBS_DETAIL_COMPANY_CONTACT_MESSAGE": "Message",
    "JOBS_DETAIL_COMPANY_CONTACT_PREVIOUS_COMPANY": "Used to work at  {company}",
    "JOBS_DETAIL_COMPANY_CONTACT_SECOND_DEGREE_HINT": "Knows someone who works there",
    "JOBS_DETAIL_COMPANY_CONTACT_TITLE": "Company contact",
    "JOBS_DETAIL_COMPANY_CULTURE_ASSESSMENT_CTA_BODY_COPY": "Start assessment",
    "JOBS_DETAIL_COMPANY_CULTURE_ASSESSMENT_CTA_HEADER": "Which employers are right for you?",
    "JOBS_DETAIL_COMPANY_CULTURE_ASSESSMENT_CTA_META": "Take the culture assessment now to find out.",
    "JOBS_DETAIL_COMPANY_CULTURE_COMPASS_LEGEND_LEFT": "<top>Traditional</top>culture",
    "JOBS_DETAIL_COMPANY_CULTURE_COMPASS_LEGEND_RIGHT": "<top>Modern</top>culture",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_LEADERSHIP": "Leadership",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_LEADERSHIP_LEGEND_LEFT": "Guiding",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_LEADERSHIP_LEGEND_RIGHT": "Empowering",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_STRATEGIC": "Strategic direction",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_STRATEGIC_LEGEND_LEFT": "Stable",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_STRATEGIC_LEGEND_RIGHT": "Drive change",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_WORKING_TOGETHER": "Interaction",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_WORKING_TOGETHER_LEGEND_LEFT": "Result-oriented",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_WORKING_TOGETHER_LEGEND_RIGHT": "People-oriented",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_WORKLIFE": "Work-life balance",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_WORKLIFE_LEGEND_LEFT": "Work",
    "JOBS_DETAIL_COMPANY_CULTURE_DIMENSION_WORKLIFE_LEGEND_RIGHT": "Life",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_CARD_TITLE": "Feedback",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_CONFIRM_HEADLINE": "Thanks for your feedback!",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_HEADLINE": "We value your opinion",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_CANCEL_BUTTON": "Not now",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_NO_HEADLINE": "Sorry to hear that!",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_NO_TEXT": "Would you be interested in telling us more?",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_OK_BUTTON": "Yes, sure",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_PARTIALLY_HEADLINE": "Thanks for your feedback!",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_PARTIALLY_TEXT": "Would you be interested in telling us more?",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_YES_HEADLINE": "Glad to hear it!",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_MORE_YES_TEXT": "Would you be interested in telling us more?",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_OPTION_NO": "No",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_OPTION_PARTIALLY": "Somewhat",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_OPTION_YES": "Yes",
    "JOBS_DETAIL_COMPANY_CULTURE_FEEDBACK_TEXT": "Did you find this information about corporate culture useful?",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_BALANCED": " The industry average is more of a balance between traditional and modern.",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_IN_LINE": " This is in line with the industry average.",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_NOT_BALANCED": " The industry average {verb} {industryWeight} towards being {cultureBinaryIndustry}.",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_1": "tends",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_2": "leans",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_3": "tends",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_VERB_4": "gravitates",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_WEIGHT_LIGHT": "slightly",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INDUSTRY_WEIGHT_STRONG": "strongly",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_INTRO": "‪{totalCultureReviews}‬ employees at ‪{companyName}‬ have rated their company's corporate culture",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_PROFILE_BALANCED": " as a balance between traditional and modern.",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_PROFILE_BINARY": " as being {profileWeight} {cultureBinaryProfile}.",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_PROFILE_WEIGHT_LIGHT": "slightly",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_PROFILE_WEIGHT_STRONG": "very",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_VALUE_MODERN": "modern",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_COMPASS_VALUE_TRADITIONAL": "traditional",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_HEADLINE": "Culture Compass - is your company traditional or modern?",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_INTRO": "Corporate culture ratings are posted anonymously by staff and based on up to 40 from a total of 160 characteristics.",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_SHOW_MORE": "Show more",
    "JOBS_DETAIL_COMPANY_CULTURE_INFO_SUBDIMENSIONS": "The Culture Compass provides general and detailed results for 4 key dimensions: work-life balance, teamwork, leadership, and strategic direction.",
    "JOBS_DETAIL_COMPANY_CULTURE_LEGEND_INDUSTRY": "Industry average",
    "JOBS_DETAIL_COMPANY_CULTURE_LINK": "View kununu profile ",
    "JOBS_DETAIL_COMPANY_CULTURE_MOBILE_HIDE_DETAILS": "Hide details",
    "JOBS_DETAIL_COMPANY_CULTURE_MOBILE_SHOW_DETAILS": "Show details",
    "JOBS_DETAIL_COMPANY_CULTURE_REVIEW": "Based on one review",
    "JOBS_DETAIL_COMPANY_CULTURE_REVIEWS": "Based on {reviewsCount} reviews",
    "JOBS_DETAIL_COMPANY_CULTURE_TITLE": "Corporate culture",
    "JOBS_DETAIL_COMPANY_INSIGHTS_TITLE": "Employer",
    "JOBS_DETAIL_DESCRIPTION_TITLE": "Job description",
    "JOBS_DETAIL_EMPLOYEE_BENEFITS_LESS": "Show less",
    "JOBS_DETAIL_EMPLOYEE_BENEFITS_MORE": "Show more",
    "JOBS_DETAIL_EMPLOYEE_BENEFITS_TITLE": "Employee benefits",
    "JOBS_DETAIL_EMPLOYEE_INSIGHTS_TITLE": "Employee insights",
    "JOBS_DETAIL_EMPLOYEE_REVIEW": "Based on {ratingCount} review",
    "JOBS_DETAIL_EMPLOYEE_REVIEWS": "Based on {ratingCount} reviews",
    "JOBS_DETAIL_EMPLOYEE_REVIEWS_TITLE": "Overall rating",
    "JOBS_DETAIL_EMPLOYER_SHOWCASE_VIDEO": "Employer showcase video",
    "JOBS_DETAIL_EXTERNAL_URL_DESCRIPTION_NO_TRACKING_CONSENT_HEADLINE": "This job ad is served directly from an external website, and you've deactivated such content on XING in your settings (privacy > tracking).",
    "JOBS_DETAIL_EXTERNAL_URL_DESCRIPTION_NO_TRACKING_CONSENT_LINK": "But you can still {link}.",
    "JOBS_DETAIL_EXTERNAL_URL_DESCRIPTION_NO_TRACKING_CONSENT_LINK_CONTENT": "view the listing on the host website",
    "JOBS_DETAIL_FUTURE_COLLEAGUES_MODULE_LEARN_MORE": "Learn more",
    "JOBS_DETAIL_FUTURE_COLLEAGUES_MODULE_PREVIOUS_OCCUPATION": "Previous role:",
    "JOBS_DETAIL_FUTURE_COLLEAGUES_MODULE_SCHOOL": "Education:",
    "JOBS_DETAIL_FUTURE_COLLEAGUES_MODULE_TITLE": "Ask peers at {company}:",
    "JOBS_DETAIL_FUTURE_COLLEAGUES_PAGE_TITLE": "People in a similar role at {company}",
    "JOBS_DETAIL_HTML_DESCRIPTION_NO_TRACKING_CONSENT_LINK": "Watch video",
    "JOBS_DETAIL_HTML_DESCRIPTION_NO_TRACKING_CONSENT_MESSAGE": "This video is served directly from an external website, and you've deactivated such content on XING in your settings (privacy > tracking).",
    "JOBS_DETAIL_LOCATION_HEADLINE": "Location",
    "JOBS_DETAIL_PREFERRED_APPLY_METHOD_DESCRIPTION": "This employer would prefer you to apply with your XING profile. ",
    "JOBS_DETAIL_PREFERRED_APPLY_METHOD_HEADLINE": "Apply with XING profile preferred",
    "JOBS_DETAIL_PREVIOUSLY_APPLIED_CONFIRMATION": "You applied for this job on {date}.",
    "JOBS_DETAIL_SALARY_ESTIMATED_AVERAGE_LEGEND": "Estimated average salary for similar positions",
    "JOBS_DETAIL_SALARY_ESTIMATED_HEADLINE": "Salary forecast",
    "JOBS_DETAIL_SALARY_ESTIMATED_INFO": "How forecasts are calculated",
    "JOBS_DETAIL_SALARY_ESTIMATED_INFO_CONTENT": "The salary details displayed are a forecast for annual gross salaries in similar positions, including any variable  components for full-time workers. These non-binding forecasts are based on various statistical methods which draw upon anonymised XING user data and market data. The following variables influence the salary details range: the title of the job ad, the employer's location, the number of employees, the industry and career level of similar positions (provided XING has such data available). The salary range displayed is indicative of typical salary data and does not include statistical outliers. These salary details may differ from the salaries paid by the job poster.",
    "JOBS_DETAIL_SALARY_ESTIMATED_RANGE_LEGEND": "Estimated salary range for similar positions",
    "JOBS_DETAIL_SALARY_EXACT_BODY": "Provided by the company",
    "JOBS_DETAIL_SALARY_EXACT_HEADLINE": "Salary",
    "JOBS_DETAIL_SALARY_NOT_PROVIDED_FORECAST_HEADLINE": "Annual salary",
    "JOBS_DETAIL_SALARY_NOT_PROVIDED_HEADLINE": "We don't have any salary details available for this job ad.",
    "JOBS_DETAIL_SALARY_RANGE_BODY": "Provided by the company",
    "JOBS_DETAIL_SALARY_RANGE_HEADLINE": "Salary range",
    "JOBS_DETAIL_SALARY_UPSELL_BODYCOPY": "<b>Upgrade to Premium</b> today for access to salary forecasts. That way, you can make informed decisions about your next job move.",
    "JOBS_DETAIL_SALARY_UPSELL_CTA": "Go Premium now",
    "JOBS_DETAIL_SALARY_UPSELL_FORECAST_HEADLINE": "Annual salary",
    "JOBS_DETAIL_SALARY_UPSELL_HEADLINE": "Upgrade now to see the salary",
    "JOBS_DETAIL_SHARE": "Share",
    "JOBS_DETAIL_SHOW_MORE": "More contacts",
    "JOBS_EXTERNAL_APPLY_FLOW_CONFIRM_BODY": "You're now a XING member. Please check out the e-mail we sent you containing further details.",
    "JOBS_EXTERNAL_APPLY_FLOW_CONFIRM_CTA": "Start application",
    "JOBS_EXTERNAL_APPLY_FLOW_CONFIRM_HEADLINE": "Congratulations!",
    "JOBS_EXTERNAL_APPLY_FLOW_PAGE_DESCRIPTION": "With XING's assistance you can find a new job faster.",
    "JOBS_EXTERNAL_APPLY_FLOW_PAGE_TITLE": "Register & continue | XING Jobs",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_CONTACTS_BODY": "Get found by thousands of recruiters looking for talent on XING to fill their vacancies.",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_CONTACTS_HEADLINE": "Let the jobs come to you",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_CUSTOM_RECOS_BODY": "You'll receive job recommendations based on your profile.",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_CUSTOM_RECOS_HEADLINE": "Matching job recommendations",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_HEADLINE": "How XING can help you with your job search:",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_INSTANT_APPLY_BODY": "Use your XING profile to apply for many of the jobs on offer.",
    "JOBS_EXTERNAL_APPLY_FLOW_REASON_INSTANT_APPLY_HEADLINE": "Instant Apply",
    "JOBS_EXTERNAL_APPLY_FLOW_REGISTER_CTA": "Register and apply",
    "JOBS_EXTERNAL_APPLY_FLOW_REGISTER_HEADLINE": "Register now free of charge to boost your job search:",
    "JOBS_EXTERNAL_APPLY_FLOW_REGISTER_LOGIN_LINK": "Already a XING member?",
    "JOBS_EXTERNAL_APPLY_FLOW_REGISTER_SECONDARY_CTA": "Continue as guest",
    "JOBS_FLAG_NEW": "New",
    "JOBS_JOBBOX_ERROR_CONFIRMATION_MESSAGE": "Sorry, that didn't work. Please try again.",
    "JOBS_JOBBOX_SUCCESS_CONFIRMATION_MESSAGE": "Job saved",
    "JOBS_JOB_ALERT_LO_CONFIRMED_CTA": "Join XING now",
    "JOBS_JOB_DETAIL_SALARY_XING_ESTIMATED": "(XING estimate)",
    "JOBS_JOB_TEASER_PERSONAL_CONTACTS": "direct contacts",
    "JOBS_JOB_TEASER_REMOVE": "Remove",
    "JOBS_JOB_TEASER_SAVE": "Save job",
    "JOBS_JOB_TEASER_SAVED": "Saved",
    "JOBS_KUNUNU_RATED_BY": "Rated by {rating} employees",
    "JOBS_LANDING_DISCIPLINES_SUBHEADER_TITLE": "Popular disciplines",
    "JOBS_LANDING_EMPLOYER_CREATE_JOB": "Post a job",
    "JOBS_LANDING_EMPLOYER_HIRE": "For recruiters:",
    "JOBS_LANDING_LO_HERO": "Find the right job for you",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_HEADLINE": "XING – Your professional companion",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_FOUR": "Daily career news",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE": "Over 1 million jobs",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE": "Job search webinars",
    "JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO": "More than 21 million members",
    "JOBS_LANDING_LO_MARKETING_SEC_TWO_HEADLINE": "Find the right job for you",
    "JOBS_LANDING_LO_MARKETING_SEC_TWO_TEXT_ONE": "With XING you'll receive job vacancies, valuable news and tips about jobs, applications and careers, as well as employer insights.",
    "JOBS_LANDING_LO_MARKETING_SEC_TWO_TEXT_TWO": "Register now for free",
    "JOBS_LOADING_ERROR_HEADER": "No jobs right now",
    "JOBS_LOGGED_IN_CREATE_SUCCESS_TITLE": "Your search alert is now active.",
    "JOBS_LOGGED_OUT_CREATE_SUCCESS_BODY": "We just sent an e-mail to {email_address}. Please click on the link to confirm your search alert.",
    "JOBS_LOGGED_OUT_CREATE_SUCCESS_TITLE": "Almost done!",
    "JOBS_MULTIPLE_TIMES_SEARCH_ALERT_CANCEL": "No thanks",
    "JOBS_MULTIPLE_TIMES_SEARCH_ALERT_TEXT": "You’ve run this search a few times now. Perhaps you’d prefer to create a search alert to be notified of new results?",
    "JOBS_NOT_AVAILABLE_PAGE_EXPLAINER_CTA": "Search jobs now",
    "JOBS_NOT_AVAILABLE_PAGE_EXPLAINER_HEADLINE": "This job ad isn't available.",
    "JOBS_NOT_AVAILABLE_PAGE_EXPLAINER_TEXT": "Run a search to find lots of other great jobs just for you.",
    "JOBS_PAGE_HEADER_LINK_SAVED_JOBS": "Saved jobs",
    "JOBS_POSTING_ACTIONS_CREATE_ALERT": "Create search alert",
    "JOBS_POSTING_ACTIONS_SAVED_HEADER_BUTTON": "Saved",
    "JOBS_POSTING_ACTIONS_SAVE_HEADER_BUTTON": "Save job",
    "JOBS_POSTING_ACTIONS_SAVE_HEADER_BUTTON_MOBILE": "Save",
    "JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_CANCEL_BUTTON": "Cancel",
    "JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_CONFIRM_BUTTON": "Yes, discard",
    "JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_CONTENT": "Your entries will be discarded.",
    "JOBS_POSTING_APPLY_FORM_CANCEL_DIALOG_TITLE": "Discard job application?",
    "JOBS_POSTING_APPLY_FORM_ERROR_RETRY_CTA": "Try again",
    "JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_CANCEL_BUTTON": "Cancel",
    "JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_CONFIRM_BUTTON": "Discard",
    "JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_CONTENT": "You'll lose all your entries and can't undo this.",
    "JOBS_POSTING_APPLY_FORM_LO_CANCEL_DIALOG_TITLE": "Discard job application?",
    "JOBS_POSTING_APPLY_FORM_LO_COMMENTS_FIELD_ERROR": "{number} characters over the limit",
    "JOBS_POSTING_APPLY_FORM_LO_COMMENTS_FIELD_ERROR_ONE": "{number} character over the limit",
    "JOBS_POSTING_APPLY_FORM_LO_COMMENTS_FIELD_HELPER": "{number} characters left",
    "JOBS_POSTING_APPLY_FORM_LO_CONFIRMATION_BODY": "You'll receive an e-mail confirming your application soon. Good luck! To apply even faster in future, register for a free XING profile.",
    "JOBS_POSTING_APPLY_FORM_LO_CONFIRMATION_HEADLINE": "Application submitted",
    "JOBS_POSTING_APPLY_FORM_LO_CONFIRMATION_REGISTER": "Create XING profile",
    "JOBS_POSTING_APPLY_FORM_LO_CONTACT_SECTION_HEADLINE": "Mobile number (optional)",
    "JOBS_POSTING_APPLY_FORM_LO_COUNTRY_CODE_FIELD_ERROR": "Please select a country code",
    "JOBS_POSTING_APPLY_FORM_LO_COUNTRY_CODE_LABEL": "Country code",
    "JOBS_POSTING_APPLY_FORM_LO_CV_CREATION": "Create a CV with <a>Lebenslauf.com</a>",
    "JOBS_POSTING_APPLY_FORM_LO_DOCUMENTS_FIELD_ERROR": "Please add your CV.",
    "JOBS_POSTING_APPLY_FORM_LO_EMAIL_FIELD_EMPTY_ERROR": "Please enter a valid e-mail address",
    "JOBS_POSTING_APPLY_FORM_LO_EMAIL_FIELD_INVALID_ERROR": "Please check your e-mail address again",
    "JOBS_POSTING_APPLY_FORM_LO_ERROR_BODY": "Please try again.",
    "JOBS_POSTING_APPLY_FORM_LO_ERROR_HEADLINE": "That didn't work.",
    "JOBS_POSTING_APPLY_FORM_LO_FIRST_NAME_FIELD_ERROR": "Please enter your first name",
    "JOBS_POSTING_APPLY_FORM_LO_FIRST_NAME_LABEL": "First name",
    "JOBS_POSTING_APPLY_FORM_LO_HEADING": "Apply to {company} via XING",
    "JOBS_POSTING_APPLY_FORM_LO_INFO_SECTION_HEADLINE": "Your details",
    "JOBS_POSTING_APPLY_FORM_LO_LAST_NAME_FIELD_ERROR": "Please enter your last name",
    "JOBS_POSTING_APPLY_FORM_LO_LAST_NAME_LABEL": "Last name",
    "JOBS_POSTING_APPLY_FORM_LO_LOG_IN_TEXT": "<a>Log in</a> to apply with your XING profile",
    "JOBS_POSTING_APPLY_FORM_LO_PHONE_FIELD_EMPTY_ERROR": "Please enter a mobile number",
    "JOBS_POSTING_APPLY_FORM_LO_PHONE_FIELD_INVALID_ERROR": "Please check your phone number again",
    "JOBS_POSTING_APPLY_FORM_LO_XING_TERMS_AND_PRIVACY": "I accept <a1>XING's GTC</a1> and acknowledge the <a2>Privacy Policy</a2>.",
    "JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_HIGH_BODY": "Looking good! You're ready to start applying for jobs now.",
    "JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_HIGH_TITLE": " Profile completion level: High",
    "JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_LOW_BODY": "Bring your profile to life by adding more details.",
    "JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_LOW_TITLE": "Profile completion level: Low",
    "JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_MEDIUM_BODY": "Make a better impression by adding more information to your profile.",
    "JOBS_POSTING_APPLY_FORM_PROFILE_COMPLETION_MEDIUM_TITLE": "Profile completion level: Medium",
    "JOBS_POSTING_CREATED_ALERT_LIGHTBOX_CONFIRM": "OK",
    "JOBS_POSTING_CREATED_ALERT_LIGHTBOX_HEADER": "Your search alert is now active",
    "JOBS_POSTING_CREATED_ALERT_LIGHTBOX_PARAGRAPH": "Any new matching jobs will be sent daily to <strong>{email}</strong>. \nEdit your search alerts at any time in the <a href=\"{link}\">search alerts section</a>.",
    "JOBS_POSTING_CREATED_ALERT_LIGHTBOX_PARAGRAPH_TEMP": "Any new matching jobs will now be sent daily to <b>{email}</b>. \nEdit your search alerts at any time in the <a>search alerts section</a>.",
    "JOBS_POSTING_CREATE_ALERT_LIGHTBOX_CANCEL": "No thanks",
    "JOBS_POSTING_CREATE_ALERT_LIGHTBOX_CONFIRM": "Create search alert",
    "JOBS_POSTING_CREATE_ALERT_LIGHTBOX_HEADER": "Create search alert",
    "JOBS_POSTING_CREATE_ALERT_MODULE_CTA": "Create search alert",
    "JOBS_POSTING_CREATE_ALERT_MODULE_KEYWORDS": "Receive e-mails for new {keywords} jobs:",
    "JOBS_POSTING_CREATE_ALERT_MODULE_LOCATION": "Don't miss out on new jobs like this in {location}",
    "JOBS_POSTING_EASY_APPLY_FORM_ADDITIONAL_COMMENTS_BODY": "Feel free to add any comments below.",
    "JOBS_POSTING_EASY_APPLY_FORM_ADDITIONAL_COMMENTS_ERROR": "Please remove {count} characters.",
    "JOBS_POSTING_EASY_APPLY_FORM_ADDITIONAL_COMMENTS_HEADLINE": "Additional comments (optional)",
    "JOBS_POSTING_EASY_APPLY_FORM_ADDITIONAL_COMMENTS_LABEL": "Add your question or comment here",
    "JOBS_POSTING_EASY_APPLY_FORM_BACK_HEADER_BUTTON": "Back to jobs",
    "JOBS_POSTING_EASY_APPLY_FORM_CANCEL_BUTTON": "Cancel",
    "JOBS_POSTING_EASY_APPLY_FORM_CONFIRMATION_BODY": "You'll receive a XING message confirming receipt shortly. ",
    "JOBS_POSTING_EASY_APPLY_FORM_CONFIRMATION_CTA": "Got it",
    "JOBS_POSTING_EASY_APPLY_FORM_CONFIRMATION_HEADER": "Application submitted",
    "JOBS_POSTING_EASY_APPLY_FORM_CONFIRM_BUTTON": "Submit application",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_COUNTRY_CODE_EMPTY_ERROR": "Please select a country code.",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_COUNTRY_CODE_LABEL": "Country code / Country",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_COUNTRY_CODE_NOT_SELECTED": "Please select",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_EMAIL_EMPTY_ERROR": "Please enter an e-mail address.",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_EMAIL_ERROR": "Please check your e-mail address again.",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_EMAIL_LABEL": "E-mail address",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_HEADLINE": "Your contact details",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_PHONE_NUMBER_EMPTY_ERROR": "Please enter a phone number.",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_PHONE_NUMBER_ERROR": "Please check your phone number again.",
    "JOBS_POSTING_EASY_APPLY_FORM_CONTACT_DETAILS_PHONE_NUMBER_LABEL": "Phone number",
    "JOBS_POSTING_EASY_APPLY_FORM_ERROR_CTA": "Got it",
    "JOBS_POSTING_EASY_APPLY_FORM_HEADER": "Apply to {company} with your XING profile",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION": "Profile completion level: {completion} ({score}%)",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_ADVICE_HIGH": "Your profile looks great and you're ready to apply.",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_ADVICE_LOW": "Tip: {profileLink} before applying.",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_ADVICE_MEDIUM": "Tip: {profileLink} before applying.",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_ERROR": "We couldn't check your profile completion level.",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_HIGH": "High",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_LINK_LOW": "complete your XING profile",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_LINK_MEDIUM": "complete your XING profile",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_LOW": "Low",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_LOW_SCORE": "Profile completion level: {completion} (only {score}%)",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_MEDIUM": "Medium",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_COMPLETION_RETRY": "Try again",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_INFO_HEADLINE": "Preview of your profile",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_INFO_OCCUPATION": "{role} at {company}",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_INFO_PREVIEW_COPY": "We'll share your profile with this employer.",
    "JOBS_POSTING_EASY_APPLY_FORM_PROFILE_INFO_PREVIEW_LINK": "Preview your profile",
    "JOBS_POSTING_EXPIRED_NOTIFICATION_TEXT_EMAIL": "{salutation},\n\nThe following job ad you posted on XING expired at the end of its regular {days}-day term:\n\nAd title: {posting_title}\nView job ad: {posting_link}\nEnded on: {expiration_date}\n\nIf you’d like to extend the term of your ad, please go to the \"Archived\" tab in your XING JobManager and select \"Extend ad term\" in the menu on the right of the ad.\n\nYou can also use this ad as a template for a new posting by selecting \"Use as template\" instead.\n\n>> Go to your XING JobManager ({manage_link})\n\nKind regards,\n\nThe XING team",
    "JOBS_POSTING_EXPIRED_NOTIFICATION_TITLE_EMAIL": "Expiration of your job ad",
    "JOBS_POSTING_NAVIGATION_HOME": "Jobs",
    "JOBS_POSTING_NAVIGATION_NEXT": "Next job ({current} of {total})",
    "JOBS_POSTING_NAVIGATION_NEXT_MOBILE": "Next job",
    "JOBS_POSTING_NAVIGATION_PREV": "All results for {summary}",
    "JOBS_POSTING_NAVIGATION_PREV_MOBILE": "All results",
    "JOBS_POSTING_RECOS_NAVIGATION_PREV": "Back to Jobs Home",
    "JOBS_POSTING_RECOS_NAVIGATION_PREV_MOBILE": "Jobs Home",
    "JOBS_POSTING_SIMILAR_JOBS_NAVIGATION_PREV": "Back to Jobs",
    "JOBS_POSTING_SIMILAR_JOBS_NAVIGATION_PREV_MOBILE": "Jobs",
    "JOBS_POSTING_XING_APPLY_DEACTIVATED_ERROR": "This job has been deleted. Try searching for other suitable jobs now.",
    "JOBS_POSTING_XING_APPLY_DELETE_UPLOAD_ERROR": "Document not deleted. Please try again.",
    "JOBS_POSTING_XING_APPLY_NO_PRIVACY_POLICY_LINKS": "Please contact the company directly for their privacy policy.",
    "JOBS_POSTING_XING_APPLY_PRIVACY_POLICY_LINKS": "The company provided us with the following privacy-related documents:",
    "JOBS_POSTING_XING_APPLY_PRIVACY_POLICY_LINK_TEXT": "document",
    "JOBS_POSTING_XING_APPLY_TYPE_ERROR": "There's a new way to apply for this job now. Please reload the job page to use it.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_BODY": "Upload a CV, cover letter, etc.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_BODY_LO": "Upload your CV",
    "JOBS_POSTING_XING_APPLY_UPLOAD_CV_BUTTON_LO": "Upload CV",
    "JOBS_POSTING_XING_APPLY_UPLOAD_FILE_BUTTON": "Add",
    "JOBS_POSTING_XING_APPLY_UPLOAD_FILE_BUTTON_LO": "Upload file",
    "JOBS_POSTING_XING_APPLY_UPLOAD_FILE_SIZE_TOO_LARGE_ERROR": "Please replace the last file you uploaded with one that's less than 5 MB.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_GENERIC_ERROR": "Document not uploaded. Please try again.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_HEADLINE": "Documents (optional)",
    "JOBS_POSTING_XING_APPLY_UPLOAD_HEADLINE_LO": "Documents",
    "JOBS_POSTING_XING_APPLY_UPLOAD_HINT": "Upload up to 3 files (max. 5 MB each) in any of the following formats: TXT, DOC, DOCX, PDF, JPG, PNG, ODT, RTF",
    "JOBS_POSTING_XING_APPLY_UPLOAD_HINT_LO": "Upload your CV and up to two other files (e.g. a cover letter or referrals). Each file can be up to 5 MB in size and in any of the following formats: TXT, DOC, DOCX, PDF, JPG, PNG, ODT, RTF",
    "JOBS_POSTING_XING_APPLY_UPLOAD_HINT_LO_FILES": "Upload your CV and up to two other files (e.g. a cover letter or referrals).",
    "JOBS_POSTING_XING_APPLY_UPLOAD_HINT_LO_FORMAT": "Each file can be up to 5 MB in size and in any of the following formats: TXT, DOC, DOCX, PDF, JPG, PNG, ODT, RTF",
    "JOBS_POSTING_XING_APPLY_UPLOAD_IN_PROGRESS_ERROR": "Uploading your file... You can send your application once you've finished uploading.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_MAX_FILES_ALLOWED_ERROR": "You can upload up to 3 files here.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_MAX_X_FILES_ALLOWED_ERROR": "You can only upload up to {maxFiles} files here.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_MIME_TYPE_NOT_SUPPORTED_ERROR": "Please select a file in one of the following formats: txt, doc docx, pdf, jpg, png, odt, rtf.",
    "JOBS_POSTING_XING_APPLY_UPLOAD_OTHER_BUTTON_LO": "Add more documents (optional)",
    "JOBS_POSTING_XING_APPLY_UPLOAD_SINGLE_FILE_ALLOWED_ERROR": "You can only upload up a single file here.",
    "JOBS_REACT_SEARCH_DAYS_AGO": "{days} days ago",
    "JOBS_RECO_UPSELL_PROJOBS_CTA_A": "Learn more",
    "JOBS_RECO_UPSELL_PROJOBS_TEXT_A": "Get exclusive access to all the really good jobs.",
    "JOBS_RECO_UPSELL_PROJOBS_TITLE_A": "Jobs offering €50,000 or more",
    "JOBS_REGISTRATION_POPUP_BODY": "Register now for individual job recommendations and to apply directly.",
    "JOBS_REGISTRATION_POPUP_CTA": "Register",
    "JOBS_REGISTRATION_POPUP_HEADLINE": "Looking for your next career step?",
    "JOBS_SAVED_JOBS_HEADLINE_TITLE": "Saved jobs",
    "JOBS_SEARCH_ALERTS_MODAL_FREQUENCY": "<a>Please register</a> to select how often you'd like to receive search alert notifications.",
    "JOBS_SEARCH_ALERTS_MODAL_FREQUENCY_BUTTON": "Receive e-mails about new jobs",
    "JOBS_SEARCH_ALERTS_MODAL_LEGAL_TEXT": "By creating a search alert, I accept XING's <a1>GTC</a1> and acknowledge the <a2>Privacy Policy</a2>.",
    "JOBS_SEARCH_ALERTS_MODAL_SUBTITLE": "Receive e-mail notifications for new vacancies matching your search by creating a search alert for: {query}",
    "JOBS_SEARCH_ALERTS_NEWSLETTER_SUBJECT": "{nr_of_jobs} new job ads for  \"{search_alert_name}\"",
    "JOBS_SEARCH_ALERTS_NEWSLETTER_SUBJECT_SINGULAR": "{nr_of_jobs} new job ad for \"{search_alert_name}\"",
    "JOBS_SEARCH_ALERTS_NEWSLETTER_SUBJECT_ZERO": "{nr_of_jobs} job ads for \"{search_alert_name}\"",
    "JOBS_SEARCH_ALERTS_PAGE_TITLE": "Search alerts",
    "JOBS_SEARCH_ALERT_BUTTON_CREATE": "Create search alert",
    "JOBS_SEARCH_ALERT_BUTTON_CREATED": "Search alert created",
    "JOBS_SEARCH_BANNER_ALERTS_ACTIVE_CITY": "We'll let you know about any new <b>vacancies in {city}</b>.",
    "JOBS_SEARCH_BANNER_ALERTS_ACTIVE_KEYWORDS": "We'll let you know about any new <b>{position} vacancies</b>.",
    "JOBS_SEARCH_BANNER_ALERTS_ACTIVE_KEYWORDS_CITY": "We'll let you know about any new <b>{position} vacancies in {city}</b>.",
    "JOBS_SEARCH_BANNER_ALERTS_INACTIVE_CITY": "Receive notifications about new <b>vacancies in {city}</b>:",
    "JOBS_SEARCH_BANNER_ALERTS_INACTIVE_KEYWORDS": "Receive notifications about new <b>{position} vacancies</b>:",
    "JOBS_SEARCH_BANNER_ALERTS_INACTIVE_KEYWORDS_CITY": "Receive notifications about new <b>{position} vacancies in {city}</b>:",
    "JOBS_SEARCH_BANNER_ALERTS_MAX_REACHED": "You've reached the limit of {number} search alerts. To create new search alerts, you need to delete some existing ones first. <a>Edit search alerts</a>",
    "JOBS_SEARCH_EMPTY_STATE_EXPLAINER_HEADLINE_ALTERNATE": "Refine your search or create a search alert",
    "JOBS_SEARCH_EMPTY_STATE_EXPLAINER_PARAGRAPH": "Try adjusting your filters (e.g. a larger radius) or using different keywords. You can also create a search alert to receive notifications for new results based on your search.",
    "JOBS_SEARCH_EMPTY_STATE_NO_RESULTS_TITLE": "No results found",
    "JOBS_SEARCH_EMPTY_STATE_RECOMMENDATIONS_HEADLINE": "Jobs you may also be interested in:",
    "JOBS_SEARCH_ERROR_STATE_HEADLINE": "Please enter a job title, keyword or location.",
    "JOBS_SEARCH_FILTERS_LOADING": "Just a second…",
    "JOBS_SEARCH_FILTERS_TOTAL_RESULTS.one": "{count} job",
    "JOBS_SEARCH_FILTERS_TOTAL_RESULTS.other": "{count} jobs",
    "JOBS_SEARCH_FILTERS_TOTAL_RESULTS.zero": "No jobs",
    "JOBS_SEARCH_FILTERS_UPSELL_PROJOBS_BODY": "Get <b>ProJobs</b> now for exclusive access to vacancies offering €50,000 or more.",
    "JOBS_SEARCH_FILTERS_UPSELL_PROJOBS_CTA": "Unlock exclusive vacancies",
    "JOBS_SEARCH_FILTERS_UPSELL_PROJOBS_HEADER": "Exclusive job offers",
    "JOBS_SEARCH_KUNUNU_BENEFITS_1": "Flexitime",
    "JOBS_SEARCH_KUNUNU_BENEFITS_10": "Training",
    "JOBS_SEARCH_KUNUNU_BENEFITS_11": "Car park",
    "JOBS_SEARCH_KUNUNU_BENEFITS_12": "Convenient transport links",
    "JOBS_SEARCH_KUNUNU_BENEFITS_13": "Staff discounts",
    "JOBS_SEARCH_KUNUNU_BENEFITS_14": "Company car",
    "JOBS_SEARCH_KUNUNU_BENEFITS_15": "Mobile device",
    "JOBS_SEARCH_KUNUNU_BENEFITS_16": "Profit-sharing",
    "JOBS_SEARCH_KUNUNU_BENEFITS_17": "Staff events",
    "JOBS_SEARCH_KUNUNU_BENEFITS_18": "Private Internet use",
    "JOBS_SEARCH_KUNUNU_BENEFITS_19": "Dogs welcome",
    "JOBS_SEARCH_KUNUNU_BENEFITS_2": "Work from home option",
    "JOBS_SEARCH_KUNUNU_BENEFITS_3": "Canteen",
    "JOBS_SEARCH_KUNUNU_BENEFITS_4": "Restaurant tickets",
    "JOBS_SEARCH_KUNUNU_BENEFITS_5": "Childcare",
    "JOBS_SEARCH_KUNUNU_BENEFITS_6": "Company pension",
    "JOBS_SEARCH_KUNUNU_BENEFITS_7": "Accessibility",
    "JOBS_SEARCH_KUNUNU_BENEFITS_8": "Health benefits",
    "JOBS_SEARCH_KUNUNU_BENEFITS_9": "Company doctor",
    "JOBS_SEARCH_LESS_FILTERS": "Less",
    "JOBS_SEARCH_LOCATION_OFF_RESULTS_TITLE": "Check out the job we found elsewhere:",
    "JOBS_SEARCH_LOCATION_OFF_RESULTS_TITLE_PLURAL": "Check out the {jobs_found} jobs we found elsewhere:",
    "JOBS_SEARCH_MORE_FILTERS": "More",
    "JOBS_SEARCH_MORE_FILTERS_MOBILE": "Filters",
    "JOBS_SEARCH_RADIUS_FILTERS_SUMMARY": "{value} km radius",
    "JOBS_SEARCH_SEA_REGISTRATION_BODY_A": "Register now for individual job recommendations and to apply directly.",
    "JOBS_SEARCH_SEA_REGISTRATION_CTA_A": "Sign up now",
    "JOBS_SEARCH_SEA_REGISTRATION_CTA_B": "Sign up now",
    "JOBS_SEARCH_SEA_REGISTRATION_HEADLINE_A": "Looking for your next career step?",
    "JOBS_SEARCH_SEA_REGISTRATION_HEADLINE_B": "Your new job is closer than you think.",
    "JOBS_SHOW_PDF_MEATBALL_MENU_ACTION": "Show PDF",
    "JOBS_SUGGESTED_NAME_ALL_JOBS": "All job offers",
    "JOBS_TIMESTAMP_31_DAYS_AGO_MIN": "30+ days ago",
    "JOBS_TIMESTAMP_59_MINS_AGO_MAX": "Just now",
    "JOBS_TIMESTAMP_BTW_24_HRS_&_48_HRS": "Yesterday",
    "JOBS_TIMESTAMP_BTW_48_HRS_&_30_DAYS": "{number} days ago",
    "JOBS_TIMESTAMP_BTW_60_MINS_&_24_HRS": "{number, plural,=1 {1 hour ago} other {# hours ago}}",
    "JOBS_TOPBAR_TITLE_FEEDBACK": "Your feedback",
    "JOBS_TOPBAR_TITLE_JOBS": "Find jobs",
    "JOBS_TOPBAR_TITLE_JOB_APPLICATION": "Your application",
    "JOBS_TOPBAR_TITLE_JOB_POSTING": "Details",
    "JOBS_TOPBAR_TITLE_JOB_POSTING_COLLEAGUES": "In a similar role",
    "JOBS_TOPBAR_TITLE_JOB_POSTING_CONTACTS": "Is this a good employer?",
    "JOBS_TOPBAR_TITLE_SAVED_JOBS": "Saved jobs",
    "JOBS_TOPBAR_TITLE_SEARCH": "Jobs search",
    "JOBS_TOPBAR_TITLE_SEARCH_ALERTS": "Search alerts",
    "JOB_ACTION_LIST_BOOKMARK": "Bookmark job ad",
    "JOB_ACTION_LIST_MANAGE": "Manage job ad",
    "JOB_ACTIVITY_BOX_HEADLINE": "Job recommendations",
    "JOB_CLICKS_EXPLANATIONJOB_POSTINGSTATS_NUM_TELL_ME_MORES_LAB": "Interested",
    "JOB_CLOSE": "Close",
    "JOB_DASHBOARD_JOBBOX_TITLE": "Your saved jobs",
    "JOB_DASHBOARD_SALARY_SUBTITLE": "Earning what you're worth?",
    "JOB_DASHBOARD_SEARCH_ALERTS_TITLE": "Search alerts",
    "JOB_DETAILS_KUNUNU_BENEFITS_SEE_MORE": "Show all",
    "JOB_DIRECTORY_CITIES_H": "In which city would you like to work?",
    "JOB_DIRECTORY_OTHERS_H": "What job title are you looking for?",
    "JOB_HEADER_POSTING_DATE": "Posted on",
    "JOB_HOME_NO_RECOS_CITY_INDUSTRY_JOBS": "There aren't any job recommendations for you at the moment.\nHere's a list of jobs from your industry and city.",
    "JOB_JOBBOX_BACK_LINK_DESKTOP": "Back to Jobs",
    "JOB_JOBBOX_BACK_LINK_MOBILE": "Back",
    "JOB_JOBBOX_CATEGORY_APPLIED": "Applied",
    "JOB_JOBBOX_CATEGORY_INTERVIEW": "Interview arranged",
    "JOB_JOBBOX_CATEGORY_INTERVIEW_SET": "Interview arranged",
    "JOB_JOBBOX_CATEGORY_RECENTLY_VIEWED": "Recently viewed",
    "JOB_JOBBOX_CATEGORY_SAVED": "Saved",
    "JOB_JOBBOX_CHANGE_STATUS": "Change status",
    "JOB_JOBBOX_CONTACT_PERSON": "Personal contacts",
    "JOB_JOBBOX_COPY": "Found some interesting jobs on XING or elsewhere? You can save them all here. To add external job ads, just enter the link (URL):",
    "JOB_JOBBOX_CTA": "Add",
    "JOB_JOBBOX_EMPTY_CASE_APPLIED_COPY": "Here you'll see any job ads with the 'applied' status.",
    "JOB_JOBBOX_EMPTY_CASE_APPLIED_TITLE": "Have you already applied for a job?",
    "JOB_JOBBOX_EMPTY_CASE_INTERVIEW_SET_COPY": "Excellent! Mark job ads as \"interview arranged\" after receiving an invitation to an interview.",
    "JOB_JOBBOX_EMPTY_CASE_INTERVIEW_SET_TITLE": "Got some interviews lined up?",
    "JOB_JOBBOX_EMPTY_CASE_RECENTLY_VIEWED_BUTTON": "Search for jobs",
    "JOB_JOBBOX_EMPTY_CASE_RECENTLY_VIEWED_COPY": "The last 20 job ads you viewed on XING will appear here for easy access later on.",
    "JOB_JOBBOX_EMPTY_CASE_RECENTLY_VIEWED_TITLE": "Which job ads did you recently view?",
    "JOB_JOBBOX_EMPTY_CASE_SAVED_COPY": "If you save a job ad while browsing vacancies, it'll appear here.",
    "JOB_JOBBOX_EMPTY_CASE_SAVED_TITLE": "Here are your saved jobs.",
    "JOB_JOBBOX_EXPIRED_POSTING": "No longer available",
    "JOB_JOBBOX_INVALID_URL": "We didn't recognise this link as being a job ad.",
    "JOB_JOBBOX_LIGHTBOX_COPY": "Just copy the URL of the job ad from your browser and paste it here.",
    "JOB_JOBBOX_LIGHTBOX_HEADLINE": "Add job ad via URL",
    "JOB_JOBBOX_LIGHTBOX_PLACEHOLDER": "e.g. http://somewebsite.co.uk/somejob",
    "JOB_JOBBOX_LINK": "View",
    "JOB_JOBBOX_OPEN_ORIGINAL_LINK": "View original job ad",
    "JOB_JOBBOX_PAGETITLE": "Your saved jobs",
    "JOB_JOBBOX_RESET_URL_BTN": "Remove details",
    "JOB_JOBBOX_RESET_URL_HEADLINE": "We added some job ad details for you.",
    "JOB_JOBBOX_RESET_URL_TEXT": "If they contain any errors, you can remove them so you only see the link to the original job ad.",
    "JOB_JOBBOX_SUBMIT_MOBILE": "Save job ads from other websites",
    "JOB_JOBBOX_TITLE": "Your saved jobs:",
    "JOB_KUNUNU_INDUSTRY_STANDARD": "Average rating for this industry:",
    "JOB_KUNUNU_RATED_BY": "Rated by <b>{kununu_ratings_num}</b> employees",
    "JOB_MYXING_CREATE_JOB_POSTING_LINK": "Create job ad",
    "JOB_POSTINGSTATS_NUM_TELL_ME_MORES_LABEL": "Interested",
    "JOB_POSTINGS_TABLE_COLHEADER_CITY": "Location",
    "JOB_POSTINGS_TABLE_COLHEADER_DATE": "Date",
    "JOB_POSTINGS_TABLE_COLHEADER_OPTIONS": "Options",
    "JOB_POSTINGS_TABLE_COLHEADER_POSITION": "Position",
    "JOB_POSTINGS_TABLE_COLHEADER_POSTER": "Posted by",
    "JOB_POSTING_ABOUT_COMPANY_H": "About the company",
    "JOB_POSTING_APPLY_BUTTON_FORM": "Go to application form",
    "JOB_POSTING_APPLY_BUTTON_FORM_ACTION_LIST": "Application form",
    "JOB_POSTING_APPLY_BUTTON_MAIL": "Apply by e-mail",
    "JOB_POSTING_APPLY_BUTTON_MAIL_ACTION_LIST": "Apply by e-mail",
    "JOB_POSTING_APPLY_BUTTON_MESSAGE": "Apply via XING message",
    "JOB_POSTING_APPLY_BUTTON_MESSAGE_ACTION_LIST": "Apply via XING message",
    "JOB_POSTING_APPLY_CRAWLED_BUTTON_FORM_ACTION_LIST": "Apply",
    "JOB_POSTING_APPLY_MAIL_BODY": "Dear Sir/Madam,\n\nI'd like to apply for the position of {posting_function} advertised on XING.\n\nSincerely,\n{name}",
    "JOB_POSTING_APPLY_MAIL_SUBJECT": "Application: {posting_function}",
    "JOB_POSTING_APPLY_MAIL_SUBJECT_WITH_CODE": "Application: {posting_function} | Reference: {posting_job_code}",
    "JOB_POSTING_CONTACT_PATH_COMMON_H": "You have 1 shared contact:",
    "JOB_POSTING_CONTACT_PATH_FIRST_H": "Send message",
    "JOB_POSTING_CONTACT_PATH_FIRST_INFO": "Is this a good employer? Just ask:",
    "JOB_POSTING_CONTACT_PERSON_H": "Contact person",
    "JOB_POSTING_CONTACT_VIA_MESSAGE_LINK": "Send message",
    "JOB_POSTING_CREATE_TAGS_FLYOUT_TEXT": "<p><strong>4 keyword tips</strong></p>\n<ul>\n<li>Use alternative spellings, names and languages for vacancies, e.g. \"Personalreferent, Personalreferentin, Human Resources Manager, HR Consultant\"</li>\n<li>Add key qualifications and tasks, e.g. \"SAP R/3 HR, managerial experience\"</li>\n<li>Add the postcode, region and/or county/state where the position is located, e.g. \"W12 7AT, 07093, North Yorkshire, Michigan\"</li>\n<li>Industry-specific terms, e.g. \"boom operator, nuclide, employer branding\"</li>\n</ul>",
    "JOB_POSTING_DESCRIPTION_NO_PREVIEW": "Unfortunately this job ad can't be previewed.",
    "JOB_POSTING_DESIGN_AD_DESCRIPTION_INFO": "This text wil be displayed in apps and used for the search feature, so feel free to edit it.",
    "JOB_POSTING_DESIGN_AD_DESCRIPTION_LABEL": "Job description (for apps and the search feature)",
    "JOB_POSTING_DESIGN_AD_PDF_DOWNLOAD": "Upload your job ad as a PDF file.",
    "JOB_POSTING_EDITOR_VIEW_ERROR_HEADLINE": "Your job ad isn't visible for the following reasons:",
    "JOB_POSTING_EXPIRATION_TIME_LEFT": "Expires in {time}",
    "JOB_POSTING_EXPIRING_DATE": "Expiry date",
    "JOB_POSTING_EXTERNAL_CLOSE_LINK": "Close",
    "JOB_POSTING_EXTERNAL_HOVERCARD": "Please refer to XING in your job application.",
    "JOB_POSTING_HELPIFY_CONTACT": "Contact:",
    "JOB_POSTING_KUNUNU_BENEFITS_ALL_LINK": "Show all",
    "JOB_POSTING_KUNUNU_BENEFITS_ALL_LINK_NEW": "Show more benefits",
    "JOB_POSTING_KUNUNU_BENEFITS_H": "Benefits confirmed by employees",
    "JOB_POSTING_KUNUNU_POWERED_BY": "Employer reviews on",
    "JOB_POSTING_LOCATION": "Location",
    "JOB_POSTING_LOGGED_OUT_APPLY_BUTTON": "Sign up for free and apply",
    "JOB_POSTING_LOGGED_OUT_APPLY_BUTTON_SHORT": "Sign up and apply",
    "JOB_POSTING_LOGGED_OUT_APP_BUTTON": "Download free app",
    "JOB_POSTING_LOGGED_OUT_REGISTER_BUTTON": "Sign up for free",
    "JOB_POSTING_LOGGED_OUT_REGISTER_HEADLINE": "The contact person is only visible to XING members.",
    "JOB_POSTING_LOGGED_OUT_REGISTER_INTRO": "Just sign up to XING (it's free) to see the contact person.",
    "JOB_POSTING_LOGGED_OUT_REPORT_JOB": "Report job ad",
    "JOB_POSTING_METADATA_ALL_JOBS_OF_CONTACT": "(Show all their job ads)",
    "JOB_POSTING_METADATA_CONTACTS_COMPANY": "(Who do you know at this company?)",
    "JOB_POSTING_METADATA_PDF_LINK": "(Download as a PDF file)",
    "JOB_POSTING_NUMBERS_FACTS_LINK": "Show numbers and facts",
    "JOB_POSTING_OTHER_COMPANY_JOBS_MORE_LOCATIONS_LINK": "Show all {number_of_jobs} jobs at {company_name} in {number_of_locations} locations",
    "JOB_POSTING_OTHER_COMPANY_JOBS_ONE_LOCATION_LINK": "There are {number_of_jobs} more jobs in {job_location}.",
    "JOB_POSTING_PDF_DOWNLOAD": "Download PDF",
    "JOB_POSTING_PDF_DOWNLOAD_LINK": "Download PDF",
    "JOB_POSTING_PDF_MISSING_ERROR": "Please upload a PDF file.",
    "JOB_POSTING_PDF_UPLOAD": "Upload PDF",
    "JOB_POSTING_POC_EMAIL": "E-mail",
    "JOB_POSTING_POSTING_REPLIES_H": "Replies",
    "JOB_POSTING_REPORT_CANCEL_BUTTON": "Cancel",
    "JOB_POSTING_REPORT_FORM_ADD_COMMENT": "Add a comment (optional)",
    "JOB_POSTING_REPORT_FORM_COMMENT_PLACEHOLDER": "Let us know what's wrong with this job ad.",
    "JOB_POSTING_REPORT_FORM_ILLEGAL_CONTENT": "Illegal content",
    "JOB_POSTING_REPORT_FORM_NO_JOB_AD": "Not a job ad",
    "JOB_POSTING_REPORT_FORM_OTHER_ISSUE": "Other content",
    "JOB_POSTING_REPORT_FORM_WRONG_CAREER_LEVEL": "Wrong career level",
    "JOB_POSTING_REPORT_FORM_WRONG_COMPANY_NAME": "Wrong company name",
    "JOB_POSTING_REPORT_FORM_WRONG_INFORMATION": "Inaccurate content (select at least one option)",
    "JOB_POSTING_REPORT_FORM_WRONG_JOB_TYPE": "Wrong job type",
    "JOB_POSTING_REPORT_FORM_WRONG_LOCATION": "Wrong location",
    "JOB_POSTING_REPORT_LIGHTBOX_DESCRIPTION": "Reporting suspicious job ads helps us improve the quality on XING Jobs.",
    "JOB_POSTING_REPORT_LIGHTBOX_TITLE": "Report job ad",
    "JOB_POSTING_REPORT_LINK": "Report job ad",
    "JOB_POSTING_REPORT_MOBILE_LIGHTBOX_DESCRIPTION": "Reporting a job ad helps us improve your experience. We'll review this job ad as soon as possible.",
    "JOB_POSTING_REPORT_MOBILE_REPORT_BUTTON": "Report",
    "JOB_POSTING_REPORT_REPORT_BUTTON": "Report",
    "JOB_POSTING_REPORT_SUCCESS": "Job ad reported!",
    "JOB_POSTING_REPORT_SUCCESS_MSG_TEXT": "We will review the quality of this job ad as soon as possible.",
    "JOB_POSTING_REPORT_SUCCESS_MSG_TITLE": "Thanks for your report! ",
    "JOB_POSTING_SHARE_EXTERNAL_SITE_FAILED": "Unfortunately this job can only be shared on XING.",
    "JOB_POSTING_SHARE_FACEBOOK": "Post on Facebook",
    "JOB_POSTING_SHARE_HEADLINE": "Share job ad",
    "JOB_POSTING_SHARE_INFOTEXT": "This job ad will be shared when activated.",
    "JOB_POSTING_SHARE_TWITTER": "Post on Twitter",
    "JOB_POSTING_SHOW_BA_HEADLINE": "Increase your ad's reach",
    "JOB_POSTING_SHOW_BA_LINK": "Post job ad on the German Federal Employment Agency job board",
    "JOB_POSTING_SHOW_BA_TEXT": "You can increase your ad's reach by also posting it for free on the German Federal Employment Agency's job board.",
    "JOB_POSTING_SIMILAR_JOBS_BOTTOM_H": "Other jobs you may be interested in",
    "JOB_POSTING_SIMILAR_JOBS_B_EMPTY": "We don't have any similar jobs to show you at the moment.",
    "JOB_POSTING_SIMILAR_JOBS_H": "Similar jobs",
    "JOB_POSTING_TYPE_MINI_DESCRIPTION": "MINI job ad",
    "JOB_POSTING_UPSELL_LINK": "Is this your job ad?",
    "JOB_POSTING_VIEW_ROUTE_LINK": "View route",
    "JOB_POSTING_VISIBILITY_BA_ANNOTATION": "Also post this job ad for free on the German Federal Employment Agency's job board.",
    "JOB_POSTING_VISIBILITY_BA_LABEL": "German Federal Employment Agency",
    "JOB_POSTING_VISIBILITY_BA_TEXT": "German Federal Employment Agency's jobs portal",
    "JOB_POSTING_WATCH_VIDEO_LINK": "Play video",
    "JOB_POSTING_XING_APPLY_BUTTON": "Easy apply",
    "JOB_RECOS_MAIN_HEADLINE": "Tell us what kind of job recommendations you'd like to get.",
    "JOB_RECOS_MAIN_SUBHEADLINE": "These settings help us recommend you relevant jobs that match your preferences. Your XING profile will remain unchanged.",
    "JOB_RECO_REASON_INDUSTRY": "In your ideal industry {value}",
    "JOB_SEARCH_ALERTS_ALERT_NAME_ALL": "All jobs",
    "JOB_SEARCH_SORT": "Sort by",
    "JOB_SEO_CATEGORY_JOBS": "{category} Jobs",
    "JOB_SEO_CITY_JOBS": "Jobs in {city}",
    "JOB_SEO_COMPANY_JOBS": "{term} jobs",
    "JOB_SEO_JOB_TYPE_CONTRACTOR_JOBS": "Find freelancer projects now.",
    "JOB_SEO_JOB_TYPE_FULL_TIME_JOBS": "Find your new full-time job now.",
    "JOB_SEO_JOB_TYPE_INTERN_JOBS": "Find the right internship now.",
    "JOB_SEO_JOB_TYPE_PART_TIME_JOBS": "Find your new part-time job now.",
    "JOB_SEO_JOB_TYPE_SEASONAL_JOBS": "Find your next seasonal job now.",
    "JOB_SEO_JOB_TYPE_TEMPORARY_JOBS": "Find your next temporary job now.",
    "JOB_SEO_JOB_TYPE_VOLUNTARY_JOBS": "Find your new voluntary work now.",
    "JOB_SEO_META_DESCRIPTION_TAG_POSTING_DETAIL": "Apply for the position of '{function}' at {company_name} in {city}. Industry: {industry} / Job type: {job_type} / Career level: {level} / Posted on: {date}",
    "JOB_SEO_META_DESCRIPTION_TAG_POSTING_DETAIL_TEMP": "Apply for the position of ''{function}'' at {company_name} in {city}. Industry: {industry} / Job type: {job_type} / Career level: {level} / Posted on: {date}",
    "JOB_SEO_TERM_JOBS": "{term} jobs",
    "JOB_SEO_TITLE_TAG_POSTING_DETAIL": "{job_title} in {work_location}",
    "JOB_STUDENT_CREATE_TYPE_APPRENTICE": "Apprenticeship",
    "JOB_STUDENT_CREATE_TYPE_INTERNSHIP": "Internship",
    "JOB_STUDENT_CREATE_TYPE_LABEL": "Ad category",
    "JOB_STUDENT_CREATE_TYPE_PARTTIME": "Student job",
    "JOB_STUDENT_CREATE_TYPE_THESIS": "Final thesis",
    "JOB_TITLEBAR_SUFFIX": "XING Jobs",
    "JOB_TITLE_TAG_SHOW_POSTING_DETAIL": "Job: {job_title}",
    "MP_000_JOB_POSTING_HINT_1": "<strong>Short editing period</strong>: Please bear in mind that you can only edit the job title and industry information for \"LOGO\" ads within 24 hours of activation.",
    "MP_000_JOB_POSTING_HINT_2": "<strong>Extending a \"LOGO\" ad</strong>: A \"LOGO\" ad cannot simply be extended. To extend the online period for a \"LOGO\" ad, it must first be copied and pasted into a new ad.",
    "MP_000_JOB_POSTING_HINT_HEADLINE": "Notes",
    "MP_000_RESOURCE_JOB_TYPES_ANY": "(all)",
    "MP_000_RESOURCE_JOB_TYPES_CONTRACTOR": "Freelance/contract",
    "MP_000_RESOURCE_JOB_TYPES_FULL_TIME": "Full time",
    "MP_000_RESOURCE_JOB_TYPES_INTERN": "For students",
    "MP_000_RESOURCE_JOB_TYPES_PART_TIME": "Part time",
    "MP_000_RESOURCE_JOB_TYPES_SEASONAL": "Seasonal",
    "MP_000_RESOURCE_JOB_TYPES_TEMPORARY": "Temporary",
    "MP_000_RESOURCE_JOB_TYPES_VOLUNTARY": "Volunteer",
    "MP_000_RESOURCE_JOB_TYPES_VOLUNTEER": "Volunteer",
    "MP_200_SEARCH_BUTTON": "Search",
    "MP_200_SEARCH_INDUSTRY_LABEL": "Industry",
    "MP_200_SEARCH_INDUSTRY_TITLE": "industry",
    "MP_200_SEARCH_LEVEL_LABEL": "Career level",
    "MP_200_SEARCH_TYPE_LABEL": "Job type",
    "MP_201_JOB_POSTINGS_THAT_MATCH_YOUR_PROFILE": "Jobs that may interest you",
    "MP_203_DETAILS_INDUSTRY_LABEL": "Industry:",
    "MP_203_INDUSTRY_TITLE": "Other jobs in this industry",
    "MP_203_JOB_POSTINGS_PAGING_POSITION_INDICATOR": "\"(offer {current} out of {total})\"",
    "MP_203_JOB_POSTINGS_THAT_MATCH_YOUR_PROFILE": "Jobs that may interest you",
    "MP_300_INDUSTRY_LABEL": "Industry",
    "MP_400_ACTIVATE": "Activate",
    "MP_400_ACTIVATE_BUTTON": "Activate",
    "MP_700_RECOMMENDED_JOBS_SEARCH": "Search in job offers now",
    "MP_700_RECOMMENDED_JOBS_SEARCHLINK": "Search for jobs",
    "REMOTE_OPTION_FULL_REMOTE": "Remote",
    "SALARY_MODULE_RANGE_MAX": "Max.",
    "SALARY_MODULE_RANGE_MIN": "Min.",
    "SE_AGENTS_EMAIL_ADDRESS_PLACEHOLDER": "Enter an e-mail address",
    "SE_AGENTS_INVALID_EMAIL_ERROR": "Please check your e-mail address again.",
    "SE_AGENTS_JOBS_ALERT_DUPLICATED_TITLE": "This search alert already exists.",
    "SE_AGENTS_JOBS_ALERT_SUBSCRIPTION_MODULE_BODY": "Get the latest results for",
    "SE_AGENTS_JOBS_ALERT_SUBSCRIPTION_MODULE_TITLE": "Let us find you a job.",
    "SE_AGENTS_JOBS_NEW_TITLE": "Create search alert",
    "SE_AGENTS_PAGETITLE": "Search alerts",
    "SE_ALERTS_JOBS_HEADLINE": "Never miss any new vacancies again:",
    "SE_FEEDBACK_APP_OPEN_BUTTON": "Feedback",
    "SE_FIELD_JOBS_DIALOG_CONFIRMATION_HINT": "OK",
    "SE_FIELD_JOBS_DIALOG_HEADLINE_HINT": "To create a search alert, please enter a job title and city first.",
    "SE_FIELD_JOBS_DIALOG_TEXT_HINT": "Then you can go ahead and create a search alert. ",
    "SE_FIELD_JOBS_KEYWORDS_HINT": "Enter a job title",
    "SE_FIELD_JOBS_LOCATION_HINT": "Enter a location",
    "SE_FILTER_JOBS_ARTIFICIAL_LABEL": "Personal relevance",
    "SE_FILTER_JOBS_BENEFITS_LABEL": "Employee benefits",
    "SE_FILTER_JOBS_CATEGORY_LABEL": "Category",
    "SE_FILTER_JOBS_CITY_LABEL": "City",
    "SE_FILTER_JOBS_COMPANY_LABEL": "Company",
    "SE_FILTER_JOBS_COUNTRY_LABEL": "Country",
    "SE_FILTER_JOBS_DISCIPLINE_LABEL": "Discipline",
    "SE_FILTER_JOBS_INDUSTRY_LABEL": "Industry",
    "SE_FILTER_JOBS_LEVEL_LABEL": "Career level",
    "SE_FILTER_JOBS_PROJOBS_LABEL": "ProJobs",
    "SE_FILTER_JOBS_PROJOB_LABEL": "Jobs posted by top recruiters",
    "SE_FILTER_JOBS_REGION_LABEL": "Region",
    "SE_FILTER_JOBS_REMOTE_LABEL": "Workplace",
    "SE_FILTER_JOBS_ROLE_LABEL": "Position",
    "SE_FILTER_JOBS_SALARY_LABEL": "Salary",
    "SE_FILTER_JOBS_SEGMENTS_LABEL": "Employer attributes",
    "SE_FILTER_JOBS_SIZE_LABEL": "Employees",
    "SE_FILTER_JOBS_STUDENT_LABEL": "For students",
    "SE_FILTER_JOBS_SUBCATEGORY_LABEL": "Specific field",
    "SE_FILTER_JOBS_TYPE_LABEL": "Employment type",
    "SE_GENERIC_ERROR_BODY": "Something went wrong. Please try again later.",
    "SE_JOBS_PAGETITLE": "Search results in jobs",
    "SE_JOBS_SUGGESTED_NAME_KEYWORDS_LOCATION": "{keywords} in {location}",
    "SE_JOBS_SUGGESTED_NAME_LOCATION": "Jobs in {location}",
    "SE_LABEL_COMMUNITIES": "Groups",
    "SE_LABEL_COMPANIES": "Companies",
    "SE_LABEL_EVENTS": "Events",
    "SE_LABEL_MEMBERS": "Members",
    "SE_LABEL_NEWS": "News",
    "SE_NUMBER_OF_JOBS_RESULTS": "{total} jobs found",
    "SE_NUMBER_OF_JOBS_RESULTS_SINGULAR": "1 job found",
    "SE_ONLY_PROJOBS": "Exclusive jobs with ProJobs",
    "SE_SORT_JOBS_DATE_LABEL": "Newest first",
    "SE_SORT_JOBS_RATING_LABEL": "Top-rated first",
    "SE_SORT_JOBS_RELEVANCE_LABEL": "Most relevant first",
    "SE_SUMMARY_JOBS_KEYWORDS_LABEL": "Keywords",
    "SE_SUMMARY_JOBS_LOCATION_LABEL": "Location",
    "SE_TITLEBAR_SUFFIX": "XING search",
    "XJM_BREADCRUMB_HOME": "Jobs",
    "XJM_HEADER_QUICKLINK_LOGGEDINHOME_PAGE_TITLE": "Recent searches",
    "XJM_JOBS_SEO_ROLE_FAQ_HEADLINE": "Frequently asked questions",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_ANSWER": "The most popular city for {jobRole} is {firstCity}.",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_QUESTION": "Where are the most openings for the role of {jobRole}?",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_ANSWER": "{firstSkill} is especially good to have for the role of {jobRole}.",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_QUESTION": "What skills are needed for {jobRole}?",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_CITIES_ANSWER": "The most popular cities for {jobRole} are {firstCity}, {secondCity}, and {thirdCity}.",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_SKILLS_ANSWER": "{firstSkill}, {secondSkill} and {thirdSkill} are especially good to have for the role of {jobRole}.",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_CITIES_ANSWER": "The most popular cities for {jobRole} are {firstCity} and {secondCity}.",
    "XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_SKILLS_ANSWER": "{firstSkill} and {secondSkill} are especially good to have for the role of {jobRole}.",
    "XJM_JOBS_SEO_ROLE_RELATED_JOBS_HEADLINE": "Related jobs",
    "XJM_JOBS_SEO_ROLE_SALARY_DESCRIPTION": "The majority of people in the role of {jobRole} in Germany earn between {minimumSalary} and {maximumSalary}, with the average being €{averageSalary}.",
    "XJM_JOBS_SEO_ROLE_SALARY_HEADER": "How much do you earn in the role of {jobRole}?",
    "XJM_JOBS_SEO_ROLE_SALARY_LABEL": "Average annual salary",
    "XJM_META_DESCRIPTION_CATEGORY": "{category} vacancies: Find jobs at top {category} employers and interesting articles about tomorrow's working world.",
    "XJM_META_DESCRIPTION_CATEGORY_CITY": "Find great {category} vacancies in {city} - Employers with reviews, interesting articles about tomorrow's working world and valuable contacts at your dream company...",
    "XJM_META_DESCRIPTION_CATEGORY_TERM": "Find great {term} jobs in {category} - Employers with reviews, interesting articles about tomorrow's working world and valuable contacts at your dream company",
    "XJM_META_DESCRIPTION_CITY": "Find vacancies in {city}. Great jobs, employers with reviews and see who you know who works at your dream company in {city}.",
    "XJM_META_DESCRIPTION_CITY_WITH_POSTINGS": "{postings} jobs in {city} on the XING jobs network. Find just the right job for you.",
    "XJM_META_DESCRIPTION_COMPANY": "{term} jobs on the XING jobs network ✓ Browse salary ranges ✓ Find your dream job now on XING!",
    "XJM_META_DESCRIPTION_DIRECTORY_LETTER": "Here you can see all the jobs and cities starting with the letter {letter} in XING Jobs.",
    "XJM_META_DESCRIPTION_EMPLOYMENT_TYPE_CITY_WITH_POSTINGS": "{postings} {employmentType} jobs in {city} on the XING jobs network. Find just the right job for you.",
    "XJM_META_DESCRIPTION_INDEX": "More than just vacancies: Personalised job ads, job application and career tips, and see who you know who already works at your dream company...",
    "XJM_META_DESCRIPTION_JOB_TYPE": "Find {job_type} vacancies: Current job offers, top companies and interesting articles about tomorrow's working world.",
    "XJM_META_DESCRIPTION_JOB_TYPE_CATEGORY": "Find {category} {job_type} vacancies - Employers with reviews, interesting articles about tomorrow's working world and valuable contacts at your dream company...",
    "XJM_META_DESCRIPTION_JOB_TYPE_CITY": "Find great {job_type} vacancies in {city} - Employers with reviews, interesting articles about tomorrow's working world and valuable contacts at your dream company...",
    "XJM_META_DESCRIPTION_JOB_TYPE_TERM": "Find {term} {job_type} vacancies - Employers with reviews,interesting articles about tomorrow's working world and valuable contacts at your dream company...",
    "XJM_META_DESCRIPTION_SKILL": " {postings} {term} jobs on the XING jobs network. Find just the right job for you.",
    "XJM_META_DESCRIPTION_SKILL_TYPE_CITY": "{postings} {term} jobs in {city} on the XING jobs network.",
    "XJM_META_DESCRIPTION_TERM": "Find {term} jobs ✓ XING's job board ✓ Check out salary ranges for jobs ✓ Use XING Jobs and find your dream job!",
    "XJM_META_DESCRIPTION_TERM_ANY_WITH_POSTINGS": "{postings} {term} jobs in {city} on the XING jobs network. Find just the right job for you.",
    "XJM_META_DESCRIPTION_TERM_CITY": "Find {term} jobs in {city} ✓ Use XING's job board ✓ Check out salary ranges for jobs ✓ XING Jobs",
    "XJM_META_DESCRIPTION_TERM_CITY_WITH_POSTINGS": "{postings} {role} jobs in {city} on the XING jobs network. Find just the right job for you.",
    "XJM_META_DESCRIPTION_TERM_WITH_POSTINGS": "{postings} {role} jobs on the XING jobs network. Find just the right job for you.",
    "XJM_META_TITLE_CATEGORY": "Find {category} vacancies in XING Jobs!",
    "XJM_META_TITLE_CATEGORY_CITY": "Find {category} vacancies {city} in XING Jobs!",
    "XJM_META_TITLE_CATEGORY_TERM": "Find {term} jobs in {category}",
    "XJM_META_TITLE_CITY": "Find vacancies in {city} in XING Jobs!",
    "XJM_META_TITLE_CITY_WITH_DATE": "Current jobs & vacancies in {city} - {month} {year}",
    "XJM_META_TITLE_COMPANY": "{term} jobs | XING jobs network",
    "XJM_META_TITLE_DIRECTORY_LETTER": "Find a job by profession and city with {letter} | XING Jobs",
    "XJM_META_TITLE_EMPLOYMENT_TYPE_CITY_WITH_DATE": "{employmentType} jobs in {city} - {month} {year}",
    "XJM_META_TITLE_INDEX": "Jobs: Find current vacancies in XING Jobs!",
    "XJM_META_TITLE_INDEX_LI": "Jobs | XING",
    "XJM_META_TITLE_JOB_TYPE": "Find great {job_type} vacancies in XING Jobs!",
    "XJM_META_TITLE_JOB_TYPE_CATEGORY": "Find {category} {job_type} vacancies in XING Jobs!",
    "XJM_META_TITLE_JOB_TYPE_CITY": "Find {job_type} vacancies in {city} in XING Jobs!",
    "XJM_META_TITLE_JOB_TYPE_TERM": "Find {term} {job_type} vacancies in XING Jobs!",
    "XJM_META_TITLE_SKILL": "Current {term} jobs - {date}",
    "XJM_META_TITLE_SKILL_TYPE_CITY": "Current {term} jobs in {city} - {month} {year}",
    "XJM_META_TITLE_TERM": "Find the latest {term} jobs in XING Jobs!",
    "XJM_META_TITLE_TERM_ANY_WITH_DATE": "Current {term} jobs - {month} {year}",
    "XJM_META_TITLE_TERM_CITY": "Find {term} jobs in {city} | XING Jobs",
    "XJM_META_TITLE_TERM_CITY_WITH_POSTINGS": "{role} jobs in {city} - {month} {year}",
    "XJM_META_TITLE_TERM_WITH_DATE": "{role} jobs & vacancies - {month} {year}",
    "XJM_SEARCH_KEYWORD_LABEL": "Enter a job title or keyword",
    "XJM_SEARCH_LOCATION_LABEL": "Location",
    "XJM_SEARCH_LOCATION_NO_RADIUS": "No radius",
    "XJM_SEARCH_LOCATION_RADIUS": "Radius",
    "XJM_SEARCH_TITLE_CATEGORY_CITY": "{category} vacancies in {city}",
    "XJM_SEARCH_TITLE_CATEGORY_TERM": "Find {term} jobs in {category}",
    "XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY": "{employmentType} jobs in {city}",
    "XJM_SEARCH_TITLE_JOB_TYPE_CATEGORY": "Find {category} {job_type} vacancies",
    "XJM_SEARCH_TITLE_JOB_TYPE_CITY": "Find {job_type} vacancies in {city}",
    "XJM_SEARCH_TITLE_JOB_TYPE_TERM": "{job_type} {term} vacancies",
    "XJM_SEARCH_TITLE_SKILL_TYPE_CITY": "{term} jobs in {city}",
    "XJM_SEARCH_TITLE_TERM_CITY": "Find {term} vacancies in {city}",
    "XJM_SEARCH_TITLE_TERM_CITY_WITH_DATE": "{role} jobs in {city}",
    "XJM_SEO_DIRECTORY_PAGINATION_H": "Search jobs by first letter",
    "XJM_SEO_JOB_ROLE": "{term} jobs",
    "XJM_SEO_POPULAR_JOBS": "Popular jobs",
    "XJM_SEO_RADIUS": "and within a radius of {radius} km",
    "XJM_SEO_RELATED_JOB_TITLES": "Similar jobs",
    "XJM_SEO_RELATED_JOB_TITLES_BY_SKILL": "Other {skill} jobs",
    "XJM_SEO_RELATED_SKILLS_BY_JOB_ROLE": "Popular job searches",
    "XJM_SEO_TOP_CITIES_NEARBY_TITLE": "Nearby cities",
    "XJM_SEO_TOP_CITIES_TITLE": "Top cities",
    "XJM_SEO_TOP_DISCIPLINES_TITLE": "Popular discipline searches",
    "XJM_SEO_TOP_JOBS_TITLE": "Top jobs",
    "XJM_SEO_TOP_JOBS_TYPES_TITLE": "Job types",
    "XJM_SEO_TOP_JOB_ROLE_LOCATIONS": "Cities offering {role} jobs",
    "XJM_SEO_TOP_LOCATIONS_BY_SKILL": "Cities offering {skill} jobs",
    "XJM_SEO_XING_SERVICES_TITLE": "XING Services",
    "XJM_SIGNUP_NOW": "Register for free",
    "XJM_SIGNUP_TEXT": "As a XING member you'll receive regular matching job recommendations.",
    "XJM_TEASER_LINKS_JOBS": " jobs",
    "XJM_TEASER_LINKS_JOBS_IN": " <strong>jobs</strong> in",
    "XJM_TEASER_LINKS_JOB_TYPE_TITLE": "Jobs by employment type",
    "XJM_TEASER_LINKS_TERM_TITLE": "Most sought-after job titles",
    "XJM_VAMP_CAREER": "Good career opportunities",
    "XJM_VAMP_CAREER_DEVELOPMENT_DESCRIPTION": "Career & training, coaching, interesting\nduties, leadership style, salary & benefits",
    "XJM_VAMP_CAREER_DEVELOPMENT_FILTER": "Career opportunities",
    "XJM_VAMP_CUSTOM_BUTTON": "Select employer attributes",
    "XJM_VAMP_CUSTOM_TEXT": "...or something else perhaps?<br>\nChoose for yourself.",
    "XJM_VAMP_FAMILY": "Family-friendly working conditions",
    "XJM_VAMP_FAMILY_WORK_DESCRIPTION": "Work-­life balance, flexitime, home office, convenient transport links, daycare",
    "XJM_VAMP_FAMILY_WORK_FILTER": "Family-friendly working conditions",
    "XJM_VAMP_GREEN": "Social and environmental expertise",
    "XJM_VAMP_GREEN_SOCIAL_DESCRIPTION": "E.g. charitable activities, humanitarian aid, sustainable manufacturing methods, etc.",
    "XJM_VAMP_GREEN_SOCIAL_FILTER": "Social and environmental expertise",
    "XJM_VAMP_TITLE": "What should your next employer have to offer?",
    "ACTION_BLOCK_USER": "Block this user",
    "ACTION_BLOCK_USER_DIALOG_DESCRIPTION": "Blocking {displayName} means they can't view your profile or contact you via XING.",
    "ACTION_BLOCK_USER_DIALOG_TITLE": "Really block this user?",
    "ACTION_BLOCK_USER_SUCCESS": "Member blocked",
    "COMMENT_BUTTON_LABEL": "Comment",
    "CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG": "{minutesCount, plural,\n   =1 {Just now}\n   other {# minutes ago}\n}",
    "CONTENT_TIMESTAMP_DAYS_AGO_LONG": "{daysCount, plural,\n    =0 {Today}\n    one {Yesterday}\n    other {# days ago}\n}",
    "CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO": "Just now",
    "CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG": "{hoursCount, plural,\n   =1 {1 hour ago}\n   other {# hours ago}\n}",
    "CONTENT_TIMESTAMP_TODAY": "Today",
    "CONTENT_TIMESTAMP_YESTERDAY": "Yesterday",
    "CROSSPOST_SHARE_ERROR": "Sorry, but you already shared this post in 3 other groups.",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM": "Turn off",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE": "Turn off mentions?",
    "DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT": "Your name won't link to your XING profile.",
    "DUPLICATE_SHARE_ERROR": "You already shared this so your contacts are in the loop.",
    "LIKERS_LIST_HEADLINE": "Members who like this:",
    "LIKE_BUTTON_LABEL": "Like",
    "MESSAGESHTML_SEARCH_INBOX": "Search by name",
    "MESSENGER_SHARE_COMMENT_PLACEHOLDER": "Comment on your link here.",
    "MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL": "Recipients:",
    "MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER": "Enter recipients",
    "MESSENGER_SHARE_TARGET_LABEL": "Your message:",
    "SHARERS_BACK_TO_POST_LINK": "Back",
    "SHARERS_LIST_BACK_LINK": "Back",
    "SHARER_LIST_HEADLINE_MEMBERS": "{total} members shared this.",
    "SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS": "{total} members shared this.",
    "SHARER_LIST_HEADLINE_ONE_MEMBER": "One member shared this.",
    "SHARER_LIST_ITEM_GO_TO_POST_LINK": "View post",
    "SHARER_LIST_POST_NOTIFICATION": "Some posts aren't visible here due to users' privacy settings.",
    "SHARE_ACTIONSHEET_HEADER": "Share this post",
    "SHARE_BOX_DEFAULT_ERROR_MESSAGE": "Sorry, something went wrong. Please try again later.",
    "SHARE_BOX_HEADER": "Share on XING",
    "SHARE_BOX_PLACEHOLDER": "Comment on your link here.",
    "SHARE_BOX_SHARE_SUCCESS": "Thanks for sharing!",
    "SHARE_BOX_SUBMIT_SHARE": "Share",
    "SHARE_BUTTON_LABEL": "Share",
    "SHARE_CANCEL_BUTTON": "Cancel",
    "SHARE_CHAT_CONTACTS": "Select a contact",
    "SHARE_CHAT_HINT": "Your recipients will each receive a message.",
    "SHARE_COUNTER_LABEL": "{counter, plural,\n    =1 {1 share}\n    other {# shares}\n}",
    "SHARE_FEEDBACK_GROUPS_BUTTON": "View post",
    "SHARE_FEEDBACK_GROUPS_MESSAGE": "{item} shared in the {group} group",
    "SHARE_FEEDBACK_INSIDERARTICLE_LABEL": "Article",
    "SHARE_FEEDBACK_JOB_LABEL": "Job",
    "SHARE_FEEDBACK_KLARTEXT_LABEL": "Post",
    "SHARE_FEEDBACK_LINK_LABEL": "Link",
    "SHARE_FEEDBACK_MESSENGER_BUTTON": "View message",
    "SHARE_FEEDBACK_MESSENGER_MESSAGE": "{item} shared via XING message",
    "SHARE_FEEDBACK_NEWS_LABEL": "Article",
    "SHARE_FEEDBACK_PICTURE_LABEL": "Image",
    "SHARE_FEEDBACK_POST_LABEL": "Post",
    "SHARE_FEEDBACK_STARTPAGE_BUTTON": "View post",
    "SHARE_FEEDBACK_STARTPAGE_MESSAGE": "{item} shared on the homepage",
    "SHARE_FEEDBACK_VIDEO_LABEL": "Video",
    "SHARE_FETCH_ERROR": "We're having problems connecting right now. Please try again later.",
    "SHARE_FETCH_ERROR_COUNTDOWN": "Trying again in {countdown} seconds.",
    "SHARE_FETCH_ERROR_RETRY": "Try again",
    "SHARE_MOST_RECENT_CHATS": "Chats",
    "SHARE_PREVIEW_ERROR_HEADLINE": "Preview currently unavailable.",
    "SHARE_QUICKSHARE_TO_STARTPAGE": "In the feed",
    "SHARE_TEXT_BOX_LENGTH_ERROR": "{delta, plural, \none {Sorry, that's 1 character too many.} \nother {Sorry, that's # characters too many.}\n}",
    "SHARE_TO_GROUPS": "In a group",
    "SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS": "Forum",
    "SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS": "Group",
    "SHARE_TO_GROUPS_SELECTION_LABEL": "Select group:",
    "SHARE_TO_GROUPS_TEXT_PLACEHOLDER": "Comment on your link here.",
    "SHARE_TO_GROUPS_THREAD_LABEL": "Your post:",
    "SHARE_TO_GROUPS_TITLE_PLACEHOLDER": "Title",
    "SHARE_TO_MESSENGER": "Via private message",
    "SHARE_TO_MESSENGER_EMPTY_STATE": "Unfortunately there weren't any hits for {query}.",
    "SHARE_TO_STARTPAGE": "In the feed with a comment",
    "SHARE_USER_SUBTEXT_GROUPS": "Share with a group",
    "SHARE_USER_SUBTEXT_MESSAGE": "Share in a chat message",
    "SHARE_USER_SUBTEXT_STARTPAGE": "Share on XING",
    "SOCIAL_ADD_CONTACT": "Add as contact",
    "SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION": "Click on the eye icon to find out your visibility. ",
    "SOCIAL_BAR_VIEW_COUNTER_HEADING": "Your visibility",
    "SOCIAL_BAR_VIEW_COUNTER_SEEN": "For instance, this post was seen <strong>{views} times</strong>.",
    "SOCIAL_BAR_VIEW_COUNTER_TIP": "Want to increase your reach? Find out how to <a>boost your visibility on XING</a>.",
    "SOCIAL_COMMENTS_COUNTER_LABEL": "{counter, plural,\n    =0 {Be the first to comment:}\n    =1 {1 comment} \n    other {# comments}\n}",
    "SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER": "Comment here and use @ to mention others",
    "SOCIAL_COMMENTS_CREATE_PLACEHOLDER": "Enter your comment here...",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL": "Cancel",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM": "Delete",
    "SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT": "Not entirely happy with what you wrote? Edit or retract it if you like.",
    "SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE": "Delete this comment?",
    "SOCIAL_COMMENTS_DELETE_DIALOG_TEXT": "You won't be able to undo this.",
    "SOCIAL_COMMENTS_DELETE_MENTION_LABEL": "Block mentions",
    "SOCIAL_COMMENTS_FORM_PLACEHOLDER": "Comment and use @ to mention",
    "SOCIAL_COMMENTS_LOAD_MORE": "Show more comments",
    "SOCIAL_COMMENTS_PREVIOUS_COMMENTS": "Show previous comments",
    "SOCIAL_COMMENTS_PREVIOUS_REPLIES": "Show previous replies",
    "SOCIAL_COMMENTS_REPLY_PLACEHOLDER": "Reply to {authorName}",
    "SOCIAL_COMMENT_BUTTON_LABEL": "Comment",
    "SOCIAL_COMMENT_COUNTER_LABEL": "{amount} comments",
    "SOCIAL_COMMENT_CREATE_BUTTON_LABEL": "Comment",
    "SOCIAL_COMMENT_DELETED_MESSAGE": "Comment deleted.",
    "SOCIAL_COMMENT_DELETE_LABEL": "Delete comment",
    "SOCIAL_COMMENT_EDIT_LABEL": "Edit comment",
    "SOCIAL_COMMENT_ERROR_TOO_LARGE": "Please limit your comment to 20,000 characters.",
    "SOCIAL_COMMENT_LIST_EMPTY_HEADLINE": "Have your say",
    "SOCIAL_COMMENT_LIST_EMPTY_SUBLINE": "Add your voice to the conversation.",
    "SOCIAL_COMMENT_OVERFLOW_ERROR": "{amount} characters",
    "SOCIAL_COMMENT_REPORT_LABEL": "Report comment",
    "SOCIAL_COMMENT_WAS_EDITED": "Edited",
    "SOCIAL_GENERIC_REPORT": "Report",
    "SOCIAL_LIKERS_LIST_HEADLINE": "Members who like this:",
    "SOCIAL_LIKERS_LIST_POST_NOTIFICATION": "Some likes aren't visible here due to users' privacy settings.",
    "SOCIAL_PMBX_COMMENT_CONTENT_URL": "Content",
    "SOCIAL_PMBX_COMMENT_DATE": "Date",
    "SOCIAL_PMBX_COMMENT_HEADING": "Your comments and replies",
    "SOCIAL_PMBX_COMMENT_MESSAGE": "Your comment",
    "SOCIAL_PMBX_COMMENT_ORIGIN": "Where did you comment?",
    "SOCIAL_PMBX_COMMENT_TITLE": "Your comments and replies",
    "SOCIAL_PMBX_COMMENT_USER_AGENT": "User agent",
    "SOCIAL_PMBX_DESCRIPTION": "Posts on XING you liked, shared, mentioned someone or commented on",
    "SOCIAL_PMBX_MENTION_DOCUMENT_URL": "Contents",
    "SOCIAL_PMBX_MENTION_HEADING": "Your mentions",
    "SOCIAL_PMBX_MENTION_TITLE": "Your mentions",
    "SOCIAL_PMBX_REACTION_CONTENT_URL": "Content",
    "SOCIAL_PMBX_REACTION_DATE": "Date",
    "SOCIAL_PMBX_REACTION_LIKE": "Posts you like",
    "SOCIAL_PMBX_REACTION_ORIGIN": "Where did you react to this post?",
    "SOCIAL_PMBX_REACTION_TITLE": "Posts you reacted to	 ",
    "SOCIAL_PMBX_REACTION_USER_AGENT": "User agent",
    "SOCIAL_PMBX_SHARE_CONTENT_URL": "Content",
    "SOCIAL_PMBX_SHARE_DATE": "Date",
    "SOCIAL_PMBX_SHARE_GROUPS": "Posts you shared with a group",
    "SOCIAL_PMBX_SHARE_MESSAGE": "What you wrote",
    "SOCIAL_PMBX_SHARE_MESSENGER": "Posts you shared as a private message",
    "SOCIAL_PMBX_SHARE_ORIGIN": "Where did you share this post?",
    "SOCIAL_PMBX_SHARE_STARTPAGE": "Posts you shared on XING",
    "SOCIAL_PMBX_SHARE_TITLE": "Posts you shared",
    "SOCIAL_PMBX_SHARE_USER_AGENT": "User agent",
    "SOCIAL_PMBX_TITLE": "Interactions",
    "SOCIAL_REPLIES_LOAD_MORE": "Show more replies",
    "SOCIAL_REPLY_BUTTON": "Reply",
    "SOCIAL_REPLY_DISCARD_MESSAGE": "Really discard this comment?",
    "SOCIAL_REPLY_LOAD_MORE": "Show 1 more reply",
    "SOCIAL_REPLY_LOAD_MULTIPLE": "Show more comments",
    "SOCIAL_REPLY_POST_BUTTON": "Reply",
    "SOCIAL_SEND_MESSAGE": "Write a message",
    "SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS": "Members who shared this:",
    "SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK": "View post",
    "SOCIAL_SHARERS_LIST_POST_NOTIFICATION": "Some posts aren't visible here due to users' privacy settings.",
    "SOCIAL_SHARE_COUNTER_LABEL": "{amount} shares",
    "SOCIAL_SHARE_EXTERNAL_LINK_ERROR": "This link can't be shared.",
    "SOCIAL_SHOW_MORE": "Show more",
    "SOCIAL_SOCIAL_PROOF_LABEL": "{counter, plural,\n    =1 {1 like:} \n    other {# likes:}\n}",
    "SOCIAL_UPDATE_COMMENT_LABEL": "Save",
    "XING_FAQ_GUIDE_URL": "https://faq.xing.com/en/node/68237",
    "INDUSTRY_10000": "Architecture and planning",
    "INDUSTRY_100000": "Telecommunications",
    "INDUSTRY_10100": "Civil engineering",
    "INDUSTRY_10200": "Construction",
    "INDUSTRY_10300": "Building materials",
    "INDUSTRY_10400": "Architecture",
    "INDUSTRY_10500": "Gardening and landscaping",
    "INDUSTRY_110000": "Media and publishing",
    "INDUSTRY_110100": "Information services",
    "INDUSTRY_110200": "Broadcast media",
    "INDUSTRY_110300": "Publishing",
    "INDUSTRY_110400": "Film and music",
    "INDUSTRY_110500": "Journalism",
    "INDUSTRY_110600": "Translation and interpreting",
    "INDUSTRY_110700": "Copywriting and proofreading",
    "INDUSTRY_120000": "Banking and financial services",
    "INDUSTRY_120100": "Financial services",
    "INDUSTRY_120200": "Banking",
    "INDUSTRY_120300": "Investment banking",
    "INDUSTRY_120400": "Venture capital and private equity",
    "INDUSTRY_130000": "Insurance",
    "INDUSTRY_140000": "Real estate",
    "INDUSTRY_140100": "Facility management",
    "INDUSTRY_140200": "Real estate management",
    "INDUSTRY_140300": "Real estate",
    "INDUSTRY_150000": "Auditing, tax and law",
    "INDUSTRY_150100": "Legal services",
    "INDUSTRY_150200": "Auditing",
    "INDUSTRY_150300": "Tax consulting",
    "INDUSTRY_160000": "Consulting",
    "INDUSTRY_170000": "Marketing, PR and design",
    "INDUSTRY_170100": "Marketing and advertising",
    "INDUSTRY_170200": "Market research and opinion polling",
    "INDUSTRY_170300": "Graphic design",
    "INDUSTRY_170400": "Trade fairs, exhibitions and conventions",
    "INDUSTRY_170500": "PR",
    "INDUSTRY_180000": "HR services",
    "INDUSTRY_180100": "HR services and consulting",
    "INDUSTRY_180200": "Outsourcing and offshoring",
    "INDUSTRY_190000": "Civil service, associations and institutions",
    "INDUSTRY_190100": "Non-profit organisations and charities",
    "INDUSTRY_190200": "Religious institutions",
    "INDUSTRY_190300": "Public administration",
    "INDUSTRY_190400": "Politics, unions and associations",
    "INDUSTRY_190500": "Defence, judiciary and police",
    "INDUSTRY_190600": "International affairs",
    "INDUSTRY_20000": "Consumer goods and trade",
    "INDUSTRY_200000": "Education and science",
    "INDUSTRY_200100": "Research",
    "INDUSTRY_200200": "Schools and childcare",
    "INDUSTRY_200300": "Academia",
    "INDUSTRY_200400": "Childcare",
    "INDUSTRY_200500": "Coaching and training",
    "INDUSTRY_200600": "E-learning",
    "INDUSTRY_20100": "Food",
    "INDUSTRY_20200": "Beverage",
    "INDUSTRY_20300": "Tobacco products",
    "INDUSTRY_20400": "Fashion and textiles",
    "INDUSTRY_20500": "Luxury goods and jewellery",
    "INDUSTRY_20600": "Furniture and wood products",
    "INDUSTRY_20700": "Stationery",
    "INDUSTRY_20800": "Cosmetics and toiletries",
    "INDUSTRY_20900": "Glass and ceramics",
    "INDUSTRY_21000": "Import and export",
    "INDUSTRY_210000": "Health and social",
    "INDUSTRY_210100": "Hospitals",
    "INDUSTRY_210200": "Veterinary",
    "INDUSTRY_210300": "Medical practices",
    "INDUSTRY_210400": "Alternative medicine",
    "INDUSTRY_210500": "Psychology and psychotherapy",
    "INDUSTRY_210600": "Medical services",
    "INDUSTRY_210700": "Nursing sector",
    "INDUSTRY_210800": "Welfare",
    "INDUSTRY_21100": "Wholesale",
    "INDUSTRY_21200": "Retail",
    "INDUSTRY_220000": "Art, culture and sport",
    "INDUSTRY_220100": "Performing arts",
    "INDUSTRY_220200": "Photography",
    "INDUSTRY_220300": "Music",
    "INDUSTRY_220400": "Arts and crafts",
    "INDUSTRY_220500": "Museums and cultural establishments",
    "INDUSTRY_220600": "Libraries",
    "INDUSTRY_220700": "Sports clubs, sports centres and gyms",
    "INDUSTRY_220800": "Athletes, organisers and associations",
    "INDUSTRY_230000": "Other industries",
    "INDUSTRY_230100": "Gambling and betting",
    "INDUSTRY_230200": "Agriculture",
    "INDUSTRY_230300": "Forestry and hunting",
    "INDUSTRY_230400": "Fishery",
    "INDUSTRY_230500": "Other services",
    "INDUSTRY_230600": "Mining and metals",
    "INDUSTRY_230700": "Geology",
    "INDUSTRY_230800": "Security and investigation",
    "INDUSTRY_30000": "Automotive and vehicle manufacturing",
    "INDUSTRY_30100": "Automotive, motorcycles and bicycles",
    "INDUSTRY_30200": "Shipbuilding",
    "INDUSTRY_30300": "Railway locomotive and rolling stock manufacturing",
    "INDUSTRY_30400": "Traffic engineering",
    "INDUSTRY_30500": "Aerospace",
    "INDUSTRY_30600": "Vehicle rental",
    "INDUSTRY_40000": "Industry and mechanical engineering",
    "INDUSTRY_40100": "Instrumentation and control engineering",
    "INDUSTRY_40200": "Semiconductors and electronic components",
    "INDUSTRY_40300": "Printing",
    "INDUSTRY_40400": "Composites",
    "INDUSTRY_40500": "Chemicals",
    "INDUSTRY_40600": "Mineral oil processing",
    "INDUSTRY_40700": "Metal and metalworking",
    "INDUSTRY_40800": "Biotechnology and nanotechnology",
    "INDUSTRY_40900": "Plastic and rubber goods",
    "INDUSTRY_41000": "Armaments",
    "INDUSTRY_41100": "Mechanical and industrial engineering",
    "INDUSTRY_41200": "Electrical engineering",
    "INDUSTRY_41300": "Optical instruments and photographic equipment",
    "INDUSTRY_50000": "Pharmaceutical and medical technology",
    "INDUSTRY_50100": "Medical technology",
    "INDUSTRY_50200": "Pharmaceutical and medicinal products",
    "INDUSTRY_60000": "Energy, water and environment",
    "INDUSTRY_60100": "Renewable energy",
    "INDUSTRY_60200": "Energy",
    "INDUSTRY_60300": "Water supply and sanitation",
    "INDUSTRY_60400": "Waste and recycling",
    "INDUSTRY_60500": "Environmental protection",
    "INDUSTRY_70000": "Transport and logistics",
    "INDUSTRY_70100": "Public transport",
    "INDUSTRY_70200": "Rail",
    "INDUSTRY_70300": "Shipping",
    "INDUSTRY_70400": "Aviation",
    "INDUSTRY_70500": "Storage",
    "INDUSTRY_70600": "Post and forwarding",
    "INDUSTRY_80000": "Tourism and food service",
    "INDUSTRY_80100": "Hotel",
    "INDUSTRY_80200": "Restaurant and food service",
    "INDUSTRY_80300": "Travel agencies",
    "INDUSTRY_80400": "Leisure facilities",
    "INDUSTRY_90000": "Internet and IT",
    "INDUSTRY_90100": "Software",
    "INDUSTRY_90200": "IT service provider",
    "INDUSTRY_90300": "IT security",
    "INDUSTRY_90400": "Computer networking",
    "INDUSTRY_90500": "Computer hardware",
    "INDUSTRY_90600": "Consumer electronics",
    "INDUSTRY_90700": "Internet and online media",
    "INDUSTRY_90800": "Computer games",
    "A11Y_LOGO": "Go to XING homepage",
    "A11Y_SETTINGS_DROPDOWN_LABEL": "Edit settings",
    "ACTIVE_LANGUAGE": "English",
    "ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT": "Exchange",
    "BREWERY_NOCOOKIES_LINK_TARGET": "https://faq.xing.com/en/security/what-are-cookies-and-why-do-i-need-them-log",
    "BREWERY_NOCOOKIES_LINK_TEXT": "Activate cookies",
    "BREWERY_NOCOOKIES_PARAGRAPH": "You need to activate cookies to log in. Here's how to do that:",
    "BREWERY_NOCOOKIES_TITLE": "Please activate cookies.",
    "BREWERY_NOJAVASCRIPT_LINK_TARGET": "https://faq.xing.com/en/settings/enable-javascript-my-browser",
    "BREWERY_NOJAVASCRIPT_LINK_TEXT": "Activate JavaScript",
    "BREWERY_NOJAVASCRIPT_PARAGRAPH": "XING only works properly with JavaScript. Here's how to activate it:",
    "BREWERY_NOJAVASCRIPT_TITLE": "Please activate JavaScript.",
    "BUTTON_BACK": "Back",
    "BUTTON_CLOSE": "Close",
    "BUTTON_CLOSEWINDOW": "Close window",
    "BUTTON_CONTINUE": "OK",
    "CAL_DATE_FORMAT": "DD/MM/YYYY",
    "CAL_DATE_FORMAT_HINT": "DD/MM/YYYY",
    "CB_POSTING_ERROR": "Sorry, that didn't work. Please try again.",
    "COMMBOX_ACTOR_SWITCH_CANCEL": "Keep role",
    "COMMBOX_ACTOR_SWITCH_CONFIRM": "Change role",
    "COMMBOX_ACTOR_SWITCH_HEADLINE": "In what role do you want to post this?",
    "COMMBOX_ACTOR_SWITCH_HINT": "To change the author of this post, just tap on the name above.",
    "COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE": "Do you really want to change the name of the author? You'd then have to re-upload the image.",
    "COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO": "Do you really want to change the name of the author? You'd then have to re-upload the video.",
    "COMMBOX_ACTOR_SWITCH_TYPE_PAGE": "Page",
    "COMMBOX_ACTOR_SWITCH_TYPE_USER": "Member",
    "COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER": "You can add 1 more image to your post.",
    "COMMBOX_AUDIENCE_CITY_CONTACTS": "Only contacts in my city ({totalCount})",
    "COMMBOX_AUDIENCE_FOLLOWERS": "Followers only",
    "COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS": "Followers & contacts",
    "COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC": "Your post can be shared",
    "COMMBOX_AUDIENCE_FOLLOWERS_DESC": "Your post can be shared.",
    "COMMBOX_AUDIENCE_HEADLINE": "Who can see this?",
    "COMMBOX_AUDIENCE_PRIVATE": "Private (XING contacts only)",
    "COMMBOX_AUDIENCE_PRIVATE_DESC": "Your post can't be shared.",
    "COMMBOX_AUDIENCE_PRIVATE_SELECTED": "Private",
    "COMMBOX_AUDIENCE_PUBLIC": "Public",
    "COMMBOX_AUDIENCE_PUBLIC_DESC": "Anyone can see and share this.",
    "COMMBOX_BUTTON_ADD_VIDEO_LABEL": "Select video",
    "COMMBOX_BUTTON_OPEN_FILES_LABEL": "Select document",
    "COMMBOX_BUTTON_OPEN_POLL_LABEL": "Create a poll",
    "COMMBOX_CANCEL_POSTING_BUTTON_BACK": "Continue editing",
    "COMMBOX_CANCEL_POSTING_BUTTON_CANCEL": "Discard post",
    "COMMBOX_CANCEL_POSTING_HEADLINE": "Discard post?",
    "COMMBOX_CANCEL_POSTING_TEXT_MESSAGE": "You'll lose what you wrote if you discard it.",
    "COMMBOX_CHARACTERS_LEFT": "left",
    "COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT": "Select images",
    "COMMBOX_EMPTY_DROPZONE_TEXT": "JPG, BMG or PNG (max. {max_size} MB each)",
    "COMMBOX_EMPTY_DROPZONE_TITLE": "Drag & drop or select up to {max_images} images",
    "COMMBOX_EMPTY_TEXT_FIELD": "Share your thoughts, a photo or a link...",
    "COMMBOX_EMPTY_TEXT_FIELD_MENTIONS": "Create a new post (and use '@' to mention others)…",
    "COMMBOX_ENTRY_POINT_LABEL": "Text box for your post",
    "COMMBOX_ENTRY_POINT_TEXT": "What's new with you?",
    "COMMBOX_FILLED_DROPZONE_HEADER": "You can add {pictures} more images to your post.",
    "COMMBOX_FULL_FILLED_DROPZONE_HEADER": "You've reached the maximum number of photos you can post.",
    "COMMBOX_IMAGE_BUTTON_LABEL": "Add image",
    "COMMBOX_IMAGE_SIZE_UPLOAD_ERROR": "Please select an image less than 10 MB in size.",
    "COMMBOX_IMAGE_TYPE_UPLOAD_ERROR": "Please select an image in JPG or PNG format.",
    "COMMBOX_POST": "Post",
    "COMMBOX_SUCCESS_ACTION": "View post",
    "COMMBOX_SUCCESS_DESC": "Your post is now live on XING.	",
    "COMMBOX_SUCCESS_HEADLINE": "Great!",
    "COMMBOX_SUCCESS_SCHEDULED_DESC": "Your message was scheduled for {time} on {date}.",
    "COMMBOX_UPDATE_BTN": "Update",
    "COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED": "You've reached the limit of 10 images.",
    "COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE": "Your video is being prepared. This will take a moment.",
    "COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR": "Sorry, that didn't work. Please try again.",
    "COMMBOX_VIEW_POST_BTN": "View post",
    "CONTENT_ERROR_404_BUTTON": "Go to XING homepage",
    "CONTENT_ERROR_404_HEADLINE": "This page appears to have gone with the wind.",
    "CONTENT_ERROR_404_SUBLINE": "But go ahead and check out what else is on offer:",
    "CONTENT_ERROR_503_HEADLINE": "Looks like the server is playing cat and mouse with us.",
    "CONTENT_ERROR_503_SUBLINE": "Please bear with us while we get some cheese for them.",
    "CONTENT_ERROR_OFFLINE": "Please check your Internet connection and try again.",
    "CONTENT_FOLLOW": "Follow",
    "CONTENT_FOLLOWED": "Following",
    "CONTENT_SWITCHER_MORE": "More",
    "CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT": "{minutesCount, plural,\n   =1 {Now}\n   other {# mins}\n}",
    "CONTENT_TIMESTAMP_DAYS": "days",
    "CONTENT_TIMESTAMP_DAYS_AGO_SHORT": "{daysCount, plural,\n    =0 {Today}\n    one {Yesterday}\n    other {# days}\n}",
    "CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT": "{hoursCount, plural,\n   =1 {1 hr}\n   other {# hrs}\n}",
    "CONTENT_UNFOLLOW": "Do not follow",
    "CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER": "Add a title for your video here.",
    "CONTENT_VIDEO_RECOS_REASON": "Popular videos on XING",
    "DAY_NAMES": "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday",
    "DAY_NAMES_SHORT": "Mo,Tu,We,Th,Fr,Sa,Su",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES": "A company",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS": "An event",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS": "A group",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS": "A job",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS": "A person",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS": "An article",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS": "A topic",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS": "Discover the many {keyword} jobs on offer",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT": "Discover {keyword} jobs",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH": "Search suggestions",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS": "What are you looking for?",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION": "Search suggestions",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS": "Profiles you recently visited",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES": "Your recent job searches",
    "DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION": "Recommendations",
    "ERROR_SOMETHING_WENT_WRONG": "Sorry, something went wrong. Please try again later.",
    "FOOTER_LANGUAGES": "Language",
    "FRAME_HEADER_UPSELL_PREMIUM": "Go Premium",
    "FRAME_HEADER_UPSELL_PROJOBS": "Check out ProJobs",
    "FRAME_NAVIGATION_DISCO": "Discover",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE": "What do you think about the new XING app?",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Your feedback",
    "FRAME_NAVIGATION_JOBS": "Jobs",
    "FRAME_NAVIGATION_ME_HUB": "You",
    "FRAME_NAVIGATION_NETWORKING_ICON_TEXT": "Networking",
    "FRAME_NAVIGATION_PROJOBS_UPSELL": "Go ProJobs",
    "FRAME_NAVIGATION_SUPI": "Home",
    "FRAME_NAVIGATION_UPSELL_HEADLINE": "Upgrades for you",
    "FRAME_NAVIGATION_YOUR_PREMIUM": "Your Premium",
    "FRAME_NAVIGATION_YOUR_PROJOBS": "Your ProJobs",
    "HEADER_SKIP_NAVIGATION": "Skip navigation",
    "INSIDER_FOLLOWED_BY": "Followers",
    "INSIDER_FOLLOWED_BY_AND": "and",
    "INSIDER_FOLLOWED_BY_AND_MORE": "other people",
    "MALT_FILE_UPLOAD_ERROR_MESSAGE": "Unfortunately your {filesTooBig} file exceeds the {maxSize} MB limit.",
    "MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL": "Unfortunately these files exceed the {maxSize} MB limit: {filesTooBig}",
    "MALT_FILE_UPLOAD_NO_FILE": "No file selected yet",
    "MALT_FILE_UPLOAD_NUMBER_OF_FILES": "{numberOfFiles} Files",
    "MALT_FOOTER_COPYRIGHT_API": "© {siteoperator}  | All rights reserved",
    "MALT_IMAGE_UPLOAD_BROWSE_BUTTON": "Browse files",
    "MALT_TEST_RUBY_STYLE_TRANSLATION": "My name is {name}.",
    "MONTH_NAMES": "January,February,March,April,May,June,July,August,September,October,November,December",
    "MONTH_NAMES_SHORT": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
    "MYXING_LOADING_ALERT_MESSAGE": "Sorry, something  went wrong. Please reload the page.",
    "NBA_BUTTON_CANCEL": "Cancel",
    "NBA_BUTTON_CHANGE_IMAGE": "Change photo",
    "NBA_BUTTON_CONTINUE": "Continue",
    "NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT": "A good profile photo emphasises your professional image and will lead to more profile visitors.",
    "NBA_CREATE_PHOTO_CARD_GENERIC_ERROR": "Something went wrong. Please try again.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE": "Please select an image in either JPG, PNG or BMP format.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE": "Please select an image up to 20 MB in size.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX": "Max.",
    "NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN": "Min.",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE": "Profile photo",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES": "Recommended resolution: 1,024 x 1,024 px",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES": "JPG, BMP, PNG (max. 20 MB)",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK": "Upload photo",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP": "Drag and drop your image here",
    "NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR": "or",
    "NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT": "You can change this photo in your business card whenever you like.",
    "NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE": "Excellent! You've changed your profile image.",
    "NOTIFICATION_CENTER_LINK": "Notifications",
    "OPTIONS_DELETE": "Yes, do it!",
    "POLLS_TIME_REMAINING_DAYS_WEB.one": "Ends tomorrow",
    "POLLS_TIME_REMAINING_DAYS_WEB.other": "Ends in {days} days",
    "POLLS_TIME_REMAINING_DAYS_WEB.zero": "Ends today",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY": "View the guest list in ProBusiness, apply powerful filters to refine it, and save relevant people as leads.",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON": "View guest list in ProBusiness ",
    "PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE": "Looking for new leads?",
    "PROBUSINESS_BANNER_SEARCH_BODY": "View your search results in ProBusiness where you can apply powerful filters and add contacts as leads.",
    "PROBUSINESS_BANNER_SEARCH_BUTTON": "Show results in ProBusiness",
    "PROBUSINESS_BANNER_SEARCH_HEADLINE": "Generate better leads from your search results!",
    "PROBUSINESS_DROPDOWN_SHOW_RESULT": "Show in ProBusiness",
    "PROBUSINESS_NO_STATUS_AVAILABLE": "Lead status not available",
    "PROBUSINESS_SAVE_AS_LEAD": "Save as lead",
    "PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE": "Ambassadors",
    "PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT": "Ambassadors are moderators of Official XING Groups who also organise Official XING Events. There are three kinds of ambassador:",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE": "Industry Ambassadors",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK": "Browse industry groups",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB": "Moderator and proven expert in their industry",
    "PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT": "An Industry Ambassador specialises in a specific field of expertise. He hosts an industry group as a recognised expert of his special field. He supports and encourages the exchange of ideas and knowledge in his group and on official \"XING Live!\" events.",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE": "Regional Ambassadors",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK": "Browse regional groups",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB": "Official event organiser and local contact",
    "PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT": "The Regional Ambassador is the point of contact for XING related questions in your region. He is moderator of an official regional group which is open to anyone interested. Regional Amassadors regularly organise events in their region to enable their group members to get to know each other.",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE": "Topic Ambassadors",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK": "Browse topic groups",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB": "On expert on the modern world of work",
    "PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT": "Topic Ambassadors are experts for modern working life. They host groups where people discuss the future of work and organise events where those discussions are continued in workshops, keynote presentations, and meetings.",
    "PROFILE_BADGES_LAYER_MODERATOR_SUB": "Contact person and mediator for the group",
    "PROFILE_BADGES_LAYER_PREMIUM_LINK": "View all Premium benefits",
    "PROFILE_BADGES_LAYER_PREMIUM_SUB": "Handy advanced features for your business and career",
    "PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR": "Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT": "How do I become an Ambassador?",
    "PROFILE_BUSINESS_CARD_BADGE_BASIC": "Basic",
    "PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP": "Discover Premium",
    "PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR": "Industry Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_MODERATOR": "Moderator",
    "PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT": "How do I become a moderator?",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM": "Premium",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT": "How do I become a Premium Member?",
    "PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP": "Premium member",
    "PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR": "Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR": "Topic Ambassador",
    "PROFILE_BUSINESS_CARD_BADGE_XPERT": "Xpert",
    "PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT": "How do I become an Xpert?",
    "PROGRESS_BAR_LOADING_PERCENTAGE": "{percentage}% finished",
    "REMEMBER_PASSWORD": "Remember me",
    "SEARCH_TOPICS_TAB_SEARCH_BUTTON": "Search",
    "SEARCH_TOPICS_TAB_TITLE": "Topics",
    "SE_ALL_VIEW_SEARCH_RESULTS": "{max} of {total} results",
    "SE_EXTENDED_SEARCH_LIST_DESCRIPTION": "What are you looking for?",
    "SE_LABEL_JOBS": "Jobs",
    "SE_OFFICIAL_XING_GROUPS": "Official XING Groups",
    "SE_PREMIUM_FLAG_ALTTEXT": "Only Premium members",
    "SE_SELECT_MEMBERS": "Members",
    "SE_SHOW_ALL_RESULTS": "All results",
    "TOP_BAR_BACK_BUTTON_ARIA_LABEL": "Back",
    "TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM": "Back to {section}",
    "TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE": "Profile",
    "UNIVERSAL_CAREER_LEVEL_LIST": "1. Student/Intern\n2. Entry level\n3. Professional/experienced\n4. Manager/supervisor\n5. Executive (VP, SVP, etc.)\n6. Senior executive (CEO, etc.)",
    "UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST": "1001. Analysis & Statistics\n1002. Administration\n1003. Consulting\n4. Controlling & Planning\n1004. Customer Service\n1005. Purchasing, Materials Management & Logistics\n1006. Finance, Accounting & Controlling\n1007. Teaching, R&D\n1008. Health, Medical & Social\n1009. Graphic Design & Architecture\n1010. Engineering & Technical\n1011. IT & Software Development\n1012. Management & Corporate Development\n1013. Marketing & Advertising\n1014. HR\n1015. PR & Journalism\n1016. Production & Manufacturing\n1017. Product Management\n1018. Project Management\n1019. Process Planning & QA\n1020. Law\n1021. Sales & Commerce\n1022. Other Disciplines",
    "UPLOADER_ADD_IMAGE": "Add image",
    "UPLOADER_ADD_VIDEO": "Add video",
    "UPLOADER_CANCEL_UPLOAD": "Cancel upload",
    "UPLOADER_ERROR_BODY": "Please try again.",
    "UPLOADER_ERROR_HEADLINE": "Sorry, that didn't work.",
    "UPLOADER_IMAGE_LOADING_HEADLINE": "Uploading image...",
    "UPLOADER_TRY_AGAIN": "Try again",
    "UPLOADER_VIDEO_LOADED_BODY": "We are now processing it to make sure it'll look great. This may take a few minutes – but don't let that keep you from posting or sharing it now.\n\n",
    "UPLOADER_VIDEO_LOADED_HEADLINE": "Your video has been uploaded.",
    "UPLOADER_VIDEO_LOADING_HEADLINE": "Uploading video...",
    "USER_FLAG_BUTTON_ARIA_LABEL": "{type} membership badge",
    "USER_FLAG_ERROR": "This information isn't available right now.<br>\nPlease try again later.",
    "USER_FLAG_ERROR_PARAGRAPH_1": "This information isn't available right now.",
    "USER_FLAG_ERROR_PARAGRAPH_2": "Please try again later.",
    "USER_FLAG_LOADING": "Loading...",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS": "Business solutions",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT": "Business",
    "VERTICAL_NAVIGATION_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_COMMUNITIES": "Groups",
    "VERTICAL_NAVIGATION_COMPANIES": "Companies",
    "VERTICAL_NAVIGATION_CONTACTS": "Your network",
    "VERTICAL_NAVIGATION_CONTACTS_SHORT": "Network",
    "VERTICAL_NAVIGATION_CONTENT_PAGES": "News",
    "VERTICAL_NAVIGATION_EVENTS": "Events",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "The new XING app: Feedback & Help",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT": "New app",
    "VERTICAL_NAVIGATION_FOOTER_ADVERTISE": "Advertise on XING",
    "VERTICAL_NAVIGATION_FOOTER_AMIANDO": "Ticketing and event promotion",
    "VERTICAL_NAVIGATION_FOOTER_ANDROID": "Android",
    "VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN": "Cover letter editor",
    "VERTICAL_NAVIGATION_FOOTER_APPS": "Apps",
    "VERTICAL_NAVIGATION_FOOTER_APP_GALLERY": "Mobile & desktop apps",
    "VERTICAL_NAVIGATION_FOOTER_BEWERBUNG": "Job application tips",
    "VERTICAL_NAVIGATION_FOOTER_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_FOOTER_CAREER": "Careers",
    "VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE": "Career Guide",
    "VERTICAL_NAVIGATION_FOOTER_COACHES": "Coaches + Trainers",
    "VERTICAL_NAVIGATION_FOOTER_COMMUNITY": "Community",
    "VERTICAL_NAVIGATION_FOOTER_COMPANIES": "Companies",
    "VERTICAL_NAVIGATION_FOOTER_COMPANY": "Company",
    "VERTICAL_NAVIGATION_FOOTER_DEVBLOG": "Devblog",
    "VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL": "Developers",
    "VERTICAL_NAVIGATION_FOOTER_DOWNLOAD": "Downloads",
    "VERTICAL_NAVIGATION_FOOTER_EVENTS": "Events",
    "VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH": "Salary check",
    "VERTICAL_NAVIGATION_FOOTER_GROUPS": "Groups",
    "VERTICAL_NAVIGATION_FOOTER_HELP": "Help & Contact",
    "VERTICAL_NAVIGATION_FOOTER_IMPRINT": "About this site",
    "VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS": "Investor Relations",
    "VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD": "iPhone & iPad",
    "VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY": "Jobs Directory",
    "VERTICAL_NAVIGATION_FOOTER_JOB_MARKET": "Jobs",
    "VERTICAL_NAVIGATION_FOOTER_KUNUNU": "Employers",
    "VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF": "CV editor",
    "VERTICAL_NAVIGATION_FOOTER_LOGINWXING": "Log in with XING",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS": "Memberships",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION": "Cancel membership",
    "VERTICAL_NAVIGATION_FOOTER_MOBILE": "Mobile",
    "VERTICAL_NAVIGATION_FOOTER_NEWWORKSE": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY": "Member directory",
    "VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE": "Praktikum-Guide",
    "VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_FOOTER_PRESS": "Press",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY": "Privacy at XING",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY": "Privacy Policy",
    "VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_FOOTER_RESOURCES": "Resources",
    "VERTICAL_NAVIGATION_FOOTER_SERVICES": "Additional services",
    "VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER": "Recruiting with XING",
    "VERTICAL_NAVIGATION_FOOTER_TANDC": "Terms & Conditions",
    "VERTICAL_NAVIGATION_FOOTER_TRACKING": "Tracking",
    "VERTICAL_NAVIGATION_FOOTER_WINDOWS_10": "Windows 10",
    "VERTICAL_NAVIGATION_FOOTER_XAS": "Post an ad",
    "VERTICAL_NAVIGATION_FOOTER_XING_AG": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_XING_NEWS": "XING News",
    "VERTICAL_NAVIGATION_FOOTER_XING_SHARE": "XING share button",
    "VERTICAL_NAVIGATION_FOOTER_YOUR_XING": "Main Sections",
    "VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR": "BrandManager",
    "VERTICAL_NAVIGATION_HEADER_HELP": "Help",
    "VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS": "Job ads",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS": "AdManager",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE": "Coach profile",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES": "Invoices & Accounts",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT": "Log out",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES": "Memberships & invoices",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS": "ProJobs settings",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS": "Settings",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS": "View all",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON": "Search",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES": "Groups",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE": "Employer",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS": "Events",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS": "Jobs",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS": "Members",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS": "Industry News",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER": "Enter a job title, name or keyword",
    "VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN": "LicenceManager",
    "VERTICAL_NAVIGATION_HEADER_XTM": "TalentManager",
    "VERTICAL_NAVIGATION_MESSAGES": "Messages",
    "VERTICAL_NAVIGATION_MORE": "More",
    "VERTICAL_NAVIGATION_MYPROJOBS": "ProJobs",
    "VERTICAL_NAVIGATION_OTHER_SERVICES": "Other services",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER": "Go Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT": "Premium",
    "VERTICAL_NAVIGATION_PROBUSINESS": "ProBusiness",
    "VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER": "Go ProJobs",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL": "Check out ProJobs",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT": "ProJobs",
    "VERTICAL_NAVIGATION_STARTPAGE": "Home",
    "VIDEOS_AUTOPLAY": "Autoplay",
    "VIDEOS_SETTINGS": "Autoplay videos?",
    "VIDEOS_WATCH_VIDEO": "Watch video",
    "VIDEO_ENCODING_HEADLINE": "Encoding your video...",
    "VIDEO_ENCODING_MESSAGE": "Please bear with us as this may take a few minutes.",
    "VIEW_PAGE_IN_CHINESE": "View this page in Chinese",
    "VIEW_PAGE_IN_DUTCH": "View this page in Dutch",
    "VIEW_PAGE_IN_ENGLISH": "View this page in English",
    "VIEW_PAGE_IN_FINNISH": "View this page in Finnish",
    "VIEW_PAGE_IN_FRENCH": "View this page in French",
    "VIEW_PAGE_IN_GERMAN": "View this page in German",
    "VIEW_PAGE_IN_HUNGARIAN": "View this page in Hungarian",
    "VIEW_PAGE_IN_ITALIAN": "View this page in Italian",
    "VIEW_PAGE_IN_JAPANESE": "View this page in Japanese",
    "VIEW_PAGE_IN_KOREAN": "View this page in Korean",
    "VIEW_PAGE_IN_POLISH": "View this page in Polish",
    "VIEW_PAGE_IN_PORTUGUESE": "View this page in Portuguese",
    "VIEW_PAGE_IN_RUSSIAN": "View this page in Russian",
    "VIEW_PAGE_IN_SPANISH": "View this page in Spanish",
    "VIEW_PAGE_IN_SWEDISH": "View this page in Swedish",
    "VIEW_PAGE_IN_TURKISH": "View this page in Turkish",
    "XBP_NAVIGATION_ENTRY_LINK": "Manage Business Pages",
    "XDS_BACK_TO_TOP_BUTTON": "Back to top",
    "XDS_FLAG_AMBASSADOR_DIVERSE": "Ambassador",
    "XDS_FLAG_AMBASSADOR_FEMALE": "Ambassador",
    "XDS_FLAG_AMBASSADOR_MALE": "Ambassador",
    "XDS_FLAG_AMBASSADOR_NEUTRAL": "Ambassador",
    "XDS_FLAG_BASIC_DIVERSE": "Basic",
    "XDS_FLAG_BASIC_FEMALE": "Basic",
    "XDS_FLAG_BASIC_MALE": "Basic",
    "XDS_FLAG_BASIC_NEUTRAL": "Basic",
    "XDS_FLAG_BETA_DIVERSE": "Beta",
    "XDS_FLAG_BETA_FEMALE": "Beta",
    "XDS_FLAG_BETA_MALE": "Beta",
    "XDS_FLAG_BETA_NEUTRAL": "Beta",
    "XDS_FLAG_INSIDER_DIVERSE": "Insider",
    "XDS_FLAG_INSIDER_FEMALE": "Insider",
    "XDS_FLAG_INSIDER_MALE": "Insider",
    "XDS_FLAG_INSIDER_NEUTRAL": "Insider",
    "XDS_FLAG_MODERATOR_DIVERSE": "Moderator",
    "XDS_FLAG_MODERATOR_FEMALE": "Moderator",
    "XDS_FLAG_MODERATOR_MALE": "Moderator",
    "XDS_FLAG_MODERATOR_NEUTRAL": "Moderator",
    "XDS_FLAG_NEW_DIVERSE": "New",
    "XDS_FLAG_NEW_FEMALE": "New",
    "XDS_FLAG_NEW_MALE": "New",
    "XDS_FLAG_NEW_NEUTRAL": "New",
    "XDS_FLAG_PREMIUM_DIVERSE": "Premium",
    "XDS_FLAG_PREMIUM_FEMALE": "Premium",
    "XDS_FLAG_PREMIUM_MALE": "Premium",
    "XDS_FLAG_PREMIUM_NEUTRAL": "Premium",
    "XDS_FLAG_PROBUSINESS_DIVERSE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_FEMALE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_MALE": "ProBusiness",
    "XDS_FLAG_PROBUSINESS_NEUTRAL": "ProBusiness",
    "XDS_FLAG_PROCOACH_DIVERSE": "ProCoach",
    "XDS_FLAG_PROCOACH_FEMALE": "ProCoach",
    "XDS_FLAG_PROCOACH_MALE": "ProCoach",
    "XDS_FLAG_PROCOACH_NEUTRAL": "ProCoach",
    "XDS_FLAG_PROJOBS_DIVERSE": "ProJobs",
    "XDS_FLAG_PROJOBS_FEMALE": "ProJobs",
    "XDS_FLAG_PROJOBS_MALE": "ProJobs",
    "XDS_FLAG_PROJOBS_NEUTRAL": "ProJobs",
    "XDS_FLAG_PROTRAINER_DIVERSE": "ProTrainer",
    "XDS_FLAG_PROTRAINER_FEMALE": "ProTrainer",
    "XDS_FLAG_PROTRAINER_MALE": "ProTrainer",
    "XDS_FLAG_PROTRAINER_NEUTRAL": "ProTrainer",
    "XINGID_ADD_LEAD_SUCCESS": "{displayName} added to leads",
    "XINGID_REMOVE_LEAD_SUCCESS": "{displayName} removed from leads",
    "XWS_100_APP_PERMISSION_VENDOR_VIDEOS": "Access XING videos vendor API",
    "XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING": "XING videos API",
    "X_UI_HEADER_REGISTER": "Sign up",
    "X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK": "Log in",
    "CAREER_LEVEL_1": "Student/Intern",
    "CAREER_LEVEL_2": "Entry Level",
    "CAREER_LEVEL_3": "Professional/Experienced",
    "CAREER_LEVEL_4": "Manager/Supervisor",
    "CAREER_LEVEL_5": "Executive (VP, SVP, etc.)",
    "CAREER_LEVEL_6": "Senior Executive (CEO, CFO, President)",
    "COMPANY_SIZE_1": "Just me",
    "COMPANY_SIZE_2": "1-10 employees",
    "COMPANY_SIZE_3": "11-50 employees",
    "COMPANY_SIZE_4": "51-200 employees",
    "COMPANY_SIZE_5": "201-500 employees",
    "COMPANY_SIZE_6": "501-1,000 employees",
    "COMPANY_SIZE_7": "1,001-5,000 employees",
    "COMPANY_SIZE_8": "5,001-10,000 employees",
    "COMPANY_SIZE_9": "10,001 or more employees",
    "COUNTRY_LIST": "ad\	Andorra\nae\	United Arab Emirates\naf\	Afghanistan\nag\	Antigua and Barbuda\nal\	Albania\nam\	Armenia\nan\	Netherlands Antilles\nao\	Angola\naq\	Antarctica\nar\	Argentina\nat\	Austria\nau\	Australia\naz\	Azerbaijan\nba\	Bosnia and Herzegovina\nbd\	Bangladesh\nbe\	Belgium\nbf\	Burkina Faso\nbg\	Bulgaria\nbh\	Bahrain\nbi\	Burundi\nbj\	Benin\nbm\	Bermuda\nbn\	Brunei Darussalam\nbo\	Bolivia\nbr\	Brazil\nbs\	Bahamas\nbt\	Bhutan\nbw\	Botswana\nby\	Belarus\nca\	Canada\ncd\	Congo, The Democratic Republic of the\ncf\	Central African Republic\ncg\	Congo\nch\	Switzerland\nci\	Ivory Coast\ncl\	Chile\ncm\	Cameroon\ncn\	China\nco\	Colombia\ncr\	Costa Rica\ncu\	Cuba\ncv\	Cape Verde\ncy\	Cyprus\ncz\	Czech Republic\nde\	Germany\ndj\	Djibouti\ndk\	Denmark\ndo\	Dominican Republic\ndz\	Algeria\nec\	Ecuador\nee\	Estonia\neg\	Egypt\nes\	Spain\net\	Ethiopia\nfi\	Finland\nfr\	France\nga\	Gabon\ngb\	United Kingdom\nge\	Georgia\ngf\	French Guiana\ngh\	Ghana\ngi\	Gibraltar\ngl\	Greenland\ngm\	Gambia\ngn\	Guinea\ngp\	Guadeloupe\ngq\	Equatorial Guinea\ngr\	Greece\ngt\	Guatemala\ngw\	Guinea-Bissau\ngy\	Guyana\nhk\	Hong Kong\nhn\	Honduras\nhr\	Croatia\nht\	Haiti\nhu\	Hungary\nid\	Indonesia\nie\	Ireland\nil\	Israel\nin\	India\niq\	Iraq\nir\	Iran, Islamic Republic of\nis\	Iceland\nit\	Italy\njm\	Jamaica\njo\	Jordan\njp\	Japan\nke\	Kenya\nkg\	Kyrgyzstan\nkh\	Cambodia\nkm\	Comoros\nkp\	North Korea\nkr\	South Korea\nkw\	Kuwait\nkz\	Kazakhstan\nla\	Lao People's Democratic Republic\nlb\	Lebanon\nlc\	Saint Lucia\nli\	Liechtenstein\nlk\	Sri Lanka\nlr\	Liberia\nls\	Lesotho\nlt\	Lithuania\nlu\	Luxembourg\nlv\	Latvia\nma\	Morocco\nmc\	Monaco\nmd\	Moldova\nmg\	Madagascar\nmk\	Macedonia\nml\	Mali\nmn\	Mongolia\nmo\	Macau\nmq\	Martinique\nmr\	Mauritania\nmt\	Malta\nmu\	Mauritius\nmv\	Maldives\nmw\	Malawi\nmx\	Mexico\nmy\	Malaysia\nmz\	Mozambique\nna\	Namibia\nnc\	New Caledonia\nne\	Niger\nng\	Nigeria\nni\	Nicaragua\nnl\	Netherlands\nno\	Norway\nnp\	Nepal\nnz\	New Zealand\nom\	Oman\npa\	Panama\npe\	Peru\npf\	French Polynesia\npg\	Papua New Guinea\nph\	Philippines\npk\	Pakistan\npl\	Poland\npr\	Puerto Rico\npt\	Portugal\npy\	Paraguay\nro\	Romania\nru\	Russian Federation\nrw\	Rwanda\nsa\	Saudi Arabia\nsb\	Solomon Islands\nsc\	Seychelles\nsd\	Sudan\nse\	Sweden\nsg\	Singapore\nsi\	Slovenia\nsk\	Slovakia\nsl\	Sierra Leone\nsm\	San Marino\nsn\	Senegal\nso\	Somalia\nsr\	Suriname\nsv\	El Salvador\nsy\	Syrian Arab Republic\nsz\	Eswatini\ntd\	Chad\ntg\	Togo\nth\	Thailand\ntn\	Tunisia\ntr\	Turkey\ntt\	Trinidad and Tobago\ntw\	Taiwan\ntz\	Tanzania\nua\	Ukraine\nug\	Uganda\nus\	United States of America\nuy\	Uruguay\nuz\	Uzbekistan\nva\	Holy See\nve\	Venezuela\nvn\	Vietnam\nye\	Yemen\nza\	South Africa\nzm\	Zambia\nzw\	Zimbabwe",
    "COUNTRY_LIST_EXTENDED": "as\	American Samoa\nai\	Anguilla\naw\	Aruba\nbb\	Barbados\nbz\	Belize\nky\	Cayman Islands\nck\	Cook Islands\ndm\	Dominica\ner\	Eritrea\nfo\	Faroe Islands\nfj\	Fiji\ngd\	Grenada\ngu\	Guam\nvg\	Virgin Islands, British\nvi\	Virgin Islands, U.S.\nqa\	Qatar\nki\	Kiribati\nly\	Libya\nmp\	Northern Mariana Islands\nmh\	Marshall Islands\nyt\	Mayotte\nfm\	Micronesia, Federated States of\nms\	Montserrat\nnr\	Nauru\nnu\	Niue\nnf\	Norfolk Island\nom\	Oman\npw\	Palau\nre\	Réunion\nkn\	Saint Kitts and Nevis\npm\	Saint Pierre et Miquelon\nvc\	Saint Vincent and the Grenadines\nws\	Samoa\nsh\	Saint Helena\nst\	Sao Tome and Principe\ntj\	Tajikistan\ntk\	Tokelau\ntl\	Timor-Leste\nto\	Tonga\ntm\	Turkmenistan\ntc\	Turks and Caicos Islands\ntv\	Tuvalu\nvu\	Vanuatu\nwf\	Wallis and Futuna\ncx\	Christmas Island\nmm\	Myanmar\nrs\	Serbia\nme\	Montenegro\ngg\	Guernsey\nsj\	Svalbard and Jan Mayen Island\nhm\	Heard Island and McDonald Islands\nbv\	Bouvet Island\nps\	Occupied Palestine\npn\	Pitcairn Islands\num\	United States Minor Outlying Islands\ntf\	French Southern and Antarctic Lands\ngs\	South Georgia and the South Sandwich Islands\neh\	Western Sahara\nfk\	Falkland Islands\nax\	Åland Islands\nje\	Jersey                                 \ncc\	Coconut Islands   \nio\	British Indian Ocean Territory\nim\	Isle of Man\nbl\	Saint-Barthélemy\nbq\	Bonaire, Sint Eustatius and Saba\ncw\	Curaçao\nmf\	Saint-Martin (French part)\nss\	South Sudan\nsx\	Sint Maarten (Dutch part)\nxk\	Kosovo",
    "COUNTRY_LIST_INTL": "{lang, select,\n  ad {Andorra}\n  ae {United Arab Emirates}\n  af {Afghanistan}\n  ag {Antigua and Barbuda}\n  al {Albania}\n  am {Armenia}\n  an {Netherlands Antilles}\n  ao {Angola}\n  aq {Antarctica}\n  ar {Argentina}\n  at {Austria}\n  au {Australia}\n  az {Azerbaijan}\n  ba {Bosnia and Herzegovina}\n  bd {Bangladesh}\n  be {Belgium}\n  bf {Burkina Faso}\n  bg {Bulgaria}\n  bh {Bahrain}\n  bi {Burundi}\n  bj {Benin}\n  bm {Bermuda}\n  bn {Brunei Darussalam}\n  bo {Bolivia}\n  br {Brazil}\n  bs {Bahamas}\n  bt {Bhutan}\n  bw {Botswana}\n  by {Belarus}\n  ca {Canada}\n  cd {Congo, The Democratic Republic of the}\n  cf {Central African Republic}\n  cg {Congo}\n  ch {Switzerland}\n  ci {Ivory Coast}\n  cl {Chile}\n  cm {Cameroon}\n  cn {China}\n  co {Colombia}\n  cr {Costa Rica}\n  cu {Cuba}\n  cv {Cape Verde}\n  cy {Cyprus}\n  cz {Czech Republic}\n  de {Germany}\n  dj {Djibouti}\n  dk {Denmark}\n  do {Dominican Republic}\n  dz {Algeria}\n  ec {Ecuador}\n  ee {Estonia}\n  eg {Egypt}\n  es {Spain}\n  et {Ethiopia}\n  fi {Finland}\n  fr {France}\n  ga {Gabon}\n  gb {United Kingdom}\n  ge {Georgia}\n  gf {French Guiana}\n  gh {Ghana}\n  gi {Gibraltar}\n  gl {Greenland}\n  gm {Gambia}\n  gn {Guinea}\n  gp {Guadeloupe}\n  gq {Equatorial Guinea}\n  gr {Greece}\n  gt {Guatemala}\n  gw {Guinea-Bissau}\n  gy {Guyana}\n  hk {Hong Kong}\n  hn {Honduras}\n  hr {Croatia}\n  ht {Haiti}\n  hu {Hungary}\n  id {Indonesia}\n  ie {Ireland}\n  il {Israel}\n  in {India}\n  iq {Iraq}\n  ir {Iran, Islamic Republic of}\n  is {Iceland}\n  it {Italy}\n  jm {Jamaica}\n  jo {Jordan}\n  jp {Japan}\n  ke {Kenya}\n  kg {Kyrgyzstan}\n  kh {Cambodia}\n  km {Comoros}\n  kp {North Korea}\n  kr {South Korea}\n  kw {Kuwait}\n  kz {Kazakhstan}\n  la {Lao People's Democratic Republic}\n  lb {Lebanon}\n  lc {Saint Lucia}\n  li {Liechtenstein}\n  lk {Sri Lanka}\n  lr {Liberia}\n  ls {Lesotho}\n  lt {Lithuania}\n  lu {Luxembourg}\n  lv {Latvia}\n  ma {Morocco}\n  mc {Monaco}\n  md {Moldova}\n  mg {Madagascar}\n  mk {Macedonia}\n  ml {Mali}\n  mn {Mongolia}\n  mo {Macau}\n  mq {Martinique}\n  mr {Mauritania}\n  mt {Malta}\n  mu {Mauritius}\n  mv {Maldives}\n  mw {Malawi}\n  mx {Mexico}\n  my {Malaysia}\n  mz {Mozambique}\n  na {Namibia}\n  nc {New Caledonia}\n  ne {Niger}\n  ng {Nigeria}\n  ni {Nicaragua}\n  nl {Netherlands}\n  no {Norway}\n  np {Nepal}\n  nz {New Zealand}\n  om {Oman}\n  pa {Panama}\n  pe {Peru}\n  pf {French Polynesia}\n  pg {Papua New Guinea}\n  ph {Philippines}\n  pk {Pakistan}\n  pl {Poland}\n  pr {Puerto Rico}\n  pt {Portugal}\n  py {Paraguay}\n  ro {Romania}\n  ru {Russian Federation}\n  rw {Rwanda}\n  sa {Saudi Arabia}\n  sb {Solomon Islands}\n  sc {Seychelles}\n  sd {Sudan}\n  se {Sweden}\n  sg {Singapore}\n  si {Slovenia}\n  sk {Slovakia}\n  sl {Sierra Leone}\n  sm {San Marino}\n  sn {Senegal}\n  so {Somalia}\n  sr {Suriname}\n  sv {El Salvador}\n  sy {Syrian Arab Republic}\n  sz {Swaziland}\n  td {Chad}\n  tg {Togo}\n  th {Thailand}\n  tn {Tunisia}\n  tr {Turkey}\n  tt {Trinidad and Tobago}\n  tw {Taiwan}\n  tz {Tanzania}\n  ua {Ukraine}\n  ug {Uganda}\n  us {United States of America}\n  uy {Uruguay}\n  uz {Uzbekistan}\n  va {Holy See}\n  ve {Venezuela}\n  vn {Vietnam}\n  ye {Yemen}\n  za {South Africa}\n  zm {Zambia}\n  zw {Zimbabwe}\n\n  as {American Samoa}\n  ai {Anguilla}\n  aw {Aruba}\n  bb {Barbados}\n  bz {Belize}\n  ky {Cayman Islands}\n  ck {Cook Islands}\n  dm {Dominica}\n  er {Eritrea}\n  fo {Faroe Islands}\n  fj {Fiji}\n  gd {Grenada}\n  gu {Guam}\n  vg {Virgin Islands, British}\n  vi {Virgin Islands, U.S.}\n  qa {Qatar}\n  ki {Kiribati}\n  ly {Libya}\n  mp {Northern Mariana Islands}\n  mh {Marshall Islands}\n  yt {Mayotte}\n  fm {Micronesia, Federated States of}\n  ms {Montserrat}\n  nr {Nauru}\n  nu {Niue}\n  nf {Norfolk Island}\n  om {Oman}\n  pw {Palau}\n  re {Réunion}\n  kn {Saint Kitts and Nevis}\n  pm {Saint Pierre et Miquelon}\n  vc {Saint Vincent and the Grenadines}\n  ws {Samoa}\n  sh {Saint Helena}\n  st {Sao Tome and Principe}\n  tj {Tajikistan}\n  tk {Tokelau}\n  tl {Timor-Leste}\n  to {Tonga}\n  tm {Turkmenistan}\n  tc {Turks and Caicos Islands}\n  tv {Tuvalu}\n  vu {Vanuatu}\n  wf {Wallis and Futuna}\n  cx {Christmas Island}\n  mm {Myanmar}\n  rs {Serbia}\n  me {Montenegro}\n  gg {Guernsey}\n  sj {Svalbard and Jan Mayen Island}\n  hm {Heard Island and McDonald Islands}\n  bv {Bouvet Island}\n  ps {Occupied Palestine}\n  pn {Pitcairn Islands}\n  um {United States Minor Outlying Islands}\n  tf {French Southern and Antarctic Lands}\n  gs {South Georgia and the South Sandwich Islands}\n  eh {Western Sahara}\n  fk {Falkland Islands}\n  ax {Åland Islands}\n  je {Jersey}\n  cc {Coconut Islands   }\n  io {British Indian Ocean Territory}\n  im {Isle of Man}\n}",
    "DISCIPLINE_1001": "Analysis and statistics",
    "DISCIPLINE_1002": "Administration",
    "DISCIPLINE_1003": "Consulting",
    "DISCIPLINE_1004": "Customer service",
    "DISCIPLINE_1005": "Purchasing, materials management & logistics",
    "DISCIPLINE_1006": "Finance, accounting & controlling",
    "DISCIPLINE_1007": "Teaching, R&D",
    "DISCIPLINE_1008": "Health, medical and social",
    "DISCIPLINE_1009": "Graphic design and architecture",
    "DISCIPLINE_1010": "Engineering and technical",
    "DISCIPLINE_1011": "IT and software development",
    "DISCIPLINE_1012": "Management and corporate development",
    "DISCIPLINE_1013": "Marketing and advertising",
    "DISCIPLINE_1014": "HR",
    "DISCIPLINE_1015": "PR and journalism",
    "DISCIPLINE_1016": "Production and manufacturing",
    "DISCIPLINE_1017": "Product management",
    "DISCIPLINE_1018": "Project management",
    "DISCIPLINE_1019": "Process planning & QA",
    "DISCIPLINE_1020": "Legal",
    "DISCIPLINE_1021": "Sales and commerce",
    "DISCIPLINE_1022": "Other",
    "EMPLOYMENT_TYPE_CONTRACTOR": "Self-employed",
    "EMPLOYMENT_TYPE_CONTRACTOR_LOCAL_SERPS": "Freelancer",
    "EMPLOYMENT_TYPE_FULL_TIME": "Full-time",
    "EMPLOYMENT_TYPE_INTERN": "Student",
    "EMPLOYMENT_TYPE_PART_TIME": "Part-time",
    "EMPLOYMENT_TYPE_SEASONAL": "Seasonal",
    "EMPLOYMENT_TYPE_TEMPORARY": "Temp",
    "EMPLOYMENT_TYPE_TEMPORARY_LOCAL_SERPS": "Mini",
    "EMPLOYMENT_TYPE_VOLUNTARY": "Volunteer",
    "INDUSTRY_LIST": "1.\	Academia \n2.\	Accounting \n3.\	Agriculture\n4.\	Airlines\n5.\	Alternative Medicine \n6.\	Apparel & Fashion\n7.\	Architecture & Planning\n8.\	Arts & Crafts \n9.\	Automotive\n10.\	Banking\n11.\	Biotechnology\n12.\	Broadcast Media\n13.\	Building Materials\n14.\	Business Supplies & Equipment\n15.\	Chemicals\n16.\	Civic & Social Organisations\n17.\	Civil Engineering\n18.\	Computer Games\n19.\	Computer Hardware\n20.\	Computer Networking\n21.\	Computer & Network Security\n22.\	Computer Software\n23.\	Construction\n24.\	Consumer Electronics\n25.\	Consumer Goods\n26.\	Consumer Services\n27.\	Cosmetics\n28.\	Daycare \n29.\	Design\n30.\	E-learning  \n31.\	Entertainment  \n32.\	Environmental Services\n33.\	Events Services  \n34.\	Facilities Services\n35.\	Financial Services\n36.\	Fishery\n37.\	Food\n38.\	Fundraising\n39.\	Furniture\n40.\	Glass & Ceramics\n41.\	Graphic Design\n42.\	Health & Fitness\n43.\	Hospitality\n44.\	Human Resources\n45.\	Import & Export\n46.\	Industrial Automation\n47.\	Information Services\n48.\	Information Technology & Services\n49.\	Insurance\n50.\	International Affairs\n51.\	International Trade & Development\n52.\	Internet\n53.\	Investment Banking\n54.\	Legal Services\n55.\	Leisure, Travel & Tourism\n56.\	Libraries\n57.\	Logistics & Supply Chain\n58.\	Luxury Goods & Jewellery\n59.\	Machinery\n60.\	Management Consulting\n61.\	Maritime\n62.\	Market Research\n63.\	Marketing & Advertising\n64.\	Mechanical/Industrial Engineering\n65.\	Media Production\n66.\	Medical Devices\n67.\	Medical Services\n68.\	Mining & Metals\n69.\	Motion Pictures\n70.\	Museums & Cultural Institutions\n71.\	Music\n72.\	Nanotechnology\n73.\	Non-Profit Organisation\n74.\	Nursing & Personal Care\n75.\	Oil & Energy\n76.\	Online Media\n77.\	Others\n78.\	Outsourcing/Offshoring\n79.\	Packaging & Containers\n80.\	Paper & Forest Products\n81.\	Medicinal Products\n82.\	Photography\n83.\	Plastics\n84.\	Printing\n85.\	Print Media\n86.\	Professional Training & Coaching\n87.\	Public Relations & Communications\n88.\	Publishing\n89.\	Railroad \n90.\	Real Estate\n91.\	Recreational Facilities & Services\n92.\	Renewables & Environment\n93.\	Research\n94.\	Restaurants & Food Service\n95.\	Retail\n96.\	Security & Investigations\n97.\	Semiconductors  \n98.\	Shipbuilding\n99.\	Sports \n100.\	Staffing & Recruiting\n101.\	Telecommunication\n102.\	Textiles  \n103.\	Translation & Localisation\n104.\	Venture Capital & Private Equity\n105.\	Veterinary  \n106.\	Wholesale  \n107.\	Wine & Spirits  \n108.\	Writing & Editing \n109.\	Politics\n110.\	Education \n111.\	Consulting \n112.\	Electrical Engineering \n113.\	Energy \n114.\	Facility Management \n115.\	Gardening/Landscaping  \n116.\	Geology\n117.\	Timber \n118.\	Journalism \n119.\	Aerospace \n120.\	Metrology/Control Engineering\n121.\	Metal/Metalworking \n122.\	Civil Service \n123.\	Pharmaceuticals \n124.\	Process Management \n125.\	Psychology/Psychotherapy \n126.\	Recycling & Waste Management \n127.\	Welfare & Community Health \n128.\	Tax accountancy/Auditing \n129.\	Theatre/Stage/Cinema \n130.\	Traffic Engineering \n131.\	Composites \n132.\	Defence/Military\n133.\	Public Health\n134.\	Transport",
    "JOBLEVEL_LIST": "1.Student/Intern  \n2.Entry Level  \n3.Professional/Experienced\n4.Manager/Supervisor\n5.Executive (VP, SVP, etc.)\n6.Senior Executive (CEO, CFO, President)",
    "LANGUAGE_SKILL_LEVEL_0": "- Language skills -",
    "LANGUAGE_SKILL_LEVEL_1": "Basic knowledge",
    "LANGUAGE_SKILL_LEVEL_2": "Good knowledge",
    "LANGUAGE_SKILL_LEVEL_3": "Fluent",
    "LANGUAGE_SKILL_LEVEL_4": "First language",
    "MSG_TYPE_employee_f": "Employee",
    "MSG_TYPE_employee_m": "Employee",
    "MSG_TYPE_employee_o": "Employee",
    "MSG_TYPE_entrepreneur_f": "Entrepreneur",
    "MSG_TYPE_entrepreneur_m": "Entrepreneur",
    "MSG_TYPE_entrepreneur_o": "Entrepreneur",
    "MSG_TYPE_executive_f": "Executive",
    "MSG_TYPE_executive_m": "Executive",
    "MSG_TYPE_executive_o": "Executive",
    "MSG_TYPE_freelancer_f": "Freelancer",
    "MSG_TYPE_freelancer_m": "Freelancer",
    "MSG_TYPE_freelancer_o": "Freelancer",
    "MSG_TYPE_public_servant_f": "Civil servant",
    "MSG_TYPE_public_servant_m": "Civil servant",
    "MSG_TYPE_public_servant_o": "Civil servant",
    "MSG_TYPE_recruiter_f": "Recruiter",
    "MSG_TYPE_recruiter_m": "Recruiter",
    "MSG_TYPE_recruiter_o": "Recruiter",
    "MSG_TYPE_retired_f": "Retired",
    "MSG_TYPE_retired_m": "Retired",
    "MSG_TYPE_retired_o": "Retired",
    "MSG_TYPE_student_f": "Student",
    "MSG_TYPE_student_m": "Student",
    "MSG_TYPE_student_o": "Student",
    "MSG_TYPE_unemployed_f": "Seeking employment",
    "MSG_TYPE_unemployed_m": "Seeking employment",
    "MSG_TYPE_unemployed_o": "Unemployed",
    "PREFSHTML_LANG_OPT_ar": "Arabic",
    "PREFSHTML_LANG_OPT_cs": "Czech",
    "PREFSHTML_LANG_OPT_d1": "German",
    "PREFSHTML_LANG_OPT_da": "Danish",
    "PREFSHTML_LANG_OPT_de": "German",
    "PREFSHTML_LANG_OPT_el": "Greek",
    "PREFSHTML_LANG_OPT_en": "English",
    "PREFSHTML_LANG_OPT_es": "Spanish",
    "PREFSHTML_LANG_OPT_fi": "Finnish",
    "PREFSHTML_LANG_OPT_fr": "French",
    "PREFSHTML_LANG_OPT_he": "Hebrew",
    "PREFSHTML_LANG_OPT_hu": "Hungarian",
    "PREFSHTML_LANG_OPT_it": "Italian",
    "PREFSHTML_LANG_OPT_ja": "Japanese",
    "PREFSHTML_LANG_OPT_ko": "Korean",
    "PREFSHTML_LANG_OPT_nl": "Dutch",
    "PREFSHTML_LANG_OPT_no": "Norwegian",
    "PREFSHTML_LANG_OPT_pl": "Polish",
    "PREFSHTML_LANG_OPT_pt": "Portuguese",
    "PREFSHTML_LANG_OPT_ro": "Romanian",
    "PREFSHTML_LANG_OPT_ru": "Russian",
    "PREFSHTML_LANG_OPT_sv": "Swedish",
    "PREFSHTML_LANG_OPT_tr": "Turkish",
    "PREFSHTML_LANG_OPT_zh": "Chinese",
    "REMOTE_OPTION_NON_REMOTE": "On-site",
    "REMOTE_OPTION_PARTLY_REMOTE": "Hybrid",
    "WORKEXPERIENCE_ORG_TYPE_LIST": "1. Publicly held corporation\n2. Privately held company\n3. Non-profit organisation\n4. Business partnership\n5. Individual enterprise\n6. Freelance",
    "WORKEXPERIENCE_SIZE_LIST": "1. Just me\n2. 1-10 employees\n3. 11-50 employees\n4. 51-200 employees\n5. 201-500 employees\n6. 501-1,000 employees\n7. 1,001-5,000 employees\n8. 5,001-10,000 employees\n9. 10,001 or more employees",
    "WORKEXPERIENCE_STATUS_1": "Full-time employee",
    "WORKEXPERIENCE_STATUS_10": "Shareholder",
    "WORKEXPERIENCE_STATUS_11": "Civil servant",
    "WORKEXPERIENCE_STATUS_12": "Recruiter",
    "WORKEXPERIENCE_STATUS_13": "Freelancer",
    "WORKEXPERIENCE_STATUS_14": "Partner",
    "WORKEXPERIENCE_STATUS_17": "Apprentice",
    "WORKEXPERIENCE_STATUS_2": "Part-time employee",
    "WORKEXPERIENCE_STATUS_3": "Intern",
    "WORKEXPERIENCE_STATUS_4": "Self-employed",
    "WORKEXPERIENCE_STATUS_5": "Owner",
    "WORKEXPERIENCE_STATUS_6": "Partner/Shareholder",
    "WORKEXPERIENCE_STATUS_7": "Board member",
    "WORKEXPERIENCE_STATUS_8": "Volunteer",
    "WORKEXPERIENCE_STATUS_9": "Self-employed",
    "WORKEXPERIENCE_STATUS_LIST": "1. Full-time employee\n2. Part-time employee\n3. Intern\n4. Freelancer/Self-employed\n5. Owner\n6. Partner/Shareholder\n7. Board member\n8. Volunteer\n9. Self-employed\n10. Shareholder\n11. Civil servant\n12. Recruiter\n13. Freelancer\n14. Partner\n17. Apprentice",
    "XE_BETA": "BETA",
    "A11Y_ADVERTISEMENT_FRAME_TITLE": "Advertisement",
    "ADVERTISEMENT_LABEL": "advertisement",
    "BENEFIT_OVERVIEW_BASIC": "Basic",
    "BENEFIT_OVERVIEW_RECRUITER": "Recruiter",
    "BENEFIT_OVERVIEW_SALES": "Sales",
    "FLMP_MENU_CREATE_PROJECT": "Create new project",
    "FLMP_MENU_FIND_PROJECT": "Find projects",
    "FLMP_MENU_OVERVIEW": "Projects overview",
    "FLMP_MENU_YOUR_SPACE": "Manage projects",
    "FOOTER_ABOUT_XING": "About XING",
    "FOOTER_ADVERTISE": "Advertise on XING",
    "FOOTER_AMIANDO_2": "Event ticketing",
    "FOOTER_BEWERBUNG": "Job application tips",
    "FOOTER_BLOG": "Blog",
    "FOOTER_COMMUNITY": "Community",
    "FOOTER_DATA_PROTECTION": "Privacy Policy",
    "FOOTER_DEVELOPER_PORTAL": "Developers",
    "FOOTER_IMPRINT": "About this site",
    "FOOTER_INVESTOR_RELATIONS": "Investor Relations",
    "FOOTER_INVITE_TO_XING": "Invite to XING",
    "FOOTER_JOBS": "Careers at Xing",
    "FOOTER_KUNUNU": "Employers",
    "FOOTER_LEBENSLAUF": "CV editor",
    "FOOTER_LOGINWXING": "Login with XING",
    "FOOTER_MEMBERSHIP_AND_PARTNER": "Products & Solutions",
    "FOOTER_MOBILE": "Mobile",
    "FOOTER_PEOPLE_DIRECTORY": "Member directory",
    "FOOTER_PRESS": "Press",
    "FOOTER_PROJOBS_UPSELL_BTN": "Go to ProJobs",
    "FOOTER_SECURITY": "Security",
    "FOOTER_TALENT_MANAGER2": "Recruiting with XING",
    "FOOTER_TANDC": "Terms & Conditions",
    "FOOTER_TOPICPAGES": "Topic portfolios",
    "FOOTER_TOP_DEALS": "Premium perks",
    "FOOTER_USEFUL": "Useful",
    "FOOTER_XAS": "Post an ad",
    "FOOTER_XING_AG": "New Work SE",
    "FOOTER_XING_SEMINARS": "XING Seminars",
    "FOOTER_YOUR_XING": "Main Sections",
    "GLOBAL_SCROLL_TOP": "Top",
    "GROUPS_NAV_OVERVIEW": "Overview",
    "HEADER_LOGIN_BUTTON": "Log in",
    "HEADER_LOGIN_EMAIL_PHONE": "E-mail",
    "HEADER_LOGIN_EMAIL_USERNAME": "E-mail",
    "HEADER_LOGIN_LAND": "Country",
    "HEADER_LOGIN_PASSWORD": "Password",
    "HEADER_LOGIN_PASSWORD_LOST": "Problems logging in",
    "HEADER_LOGIN_PHONE": "Mobile number",
    "JS_REALLY_DELETE": "Really delete?",
    "LANDINGPAGE_SHARE_LINK_FB": "Share on Facebook",
    "LANDINGPAGE_SHARE_LINK_GOOGLE": "Save as a bookmark on Google",
    "LANDINGPAGE_SHARE_LINK_TWITTER": "Share on Twitter",
    "LANDINGPAGE_SHARE_LINK_XING": "Share on XING",
    "LOGIN_NAVIGATION_LOGIN_ERROR_INVALID": "Sorry, we didn't recognise your login details just now. Could you please enter them again?",
    "META_DESCRIPTION_ALL": "XING is your professional companion. Discover great jobs and gather inspiration for your working life.",
    "MYXING_NAV_ACTIVITIES": "Comments & Likes",
    "MYXING_NAV_APPS": "Apps",
    "MYXING_NAV_BETALABS": "XING Beta Labs",
    "MYXING_NAV_COMPANIES": "Companies",
    "MYXING_NAV_CONTACTS": "Contact requests",
    "MYXING_NAV_CONTACTS_X5": "Contacts",
    "MYXING_NAV_CONTENT": "Industry News",
    "MYXING_NAV_EVENTS": "Events",
    "MYXING_NAV_GROUPS": "Groups",
    "MYXING_NAV_JOBS": "Jobs",
    "MYXING_NAV_MESSAGES": "New messages",
    "MYXING_NAV_SETTINGS_TOOLTIP": "Settings/Invoices & Accounts",
    "MYXING_PREMIUM_COCKPIT_LABEL": "Premium Hub",
    "NAVI_MYOBC": "Network news",
    "NAVI_PREMIUM_MEMBERSHIP": "Premium membership",
    "NAVI_PREMIUM_PROJOBS_ADDON": "Pro<span>Jobs</span>: Career compass.",
    "NAVI_PROJOBS_MEMBERSHIP": "ProJobs add-on",
    "NETWORKSHTML_SUB2": "Your groups",
    "NO_JAVASCRIPT_ERROR": "Please <a href=\"https://faq.xing.com/en/settings/enable-javascript-my-browser\">activate JavaScript</a> to use XING.",
    "PREMIUM_HUB_FEATURES_OFFERS_TITLE_SHORT": "Premium perks",
    "PREMIUM_NAVIGATION_OVERVIEW": "Overview",
    "PREMIUM_NAVIGATION_PREMIUM": "Premium",
    "PREMIUM_POWERSEARCH_HEADLINE": "Find members",
    "PREMIUM_POWERSEARCH_NETWORK_CHANGES": "Contact updates",
    "PREMIUM_VOMP_MODULE_HEADLINE": "Profile visitors",
    "PREMIUM_VOMP_STARTPAGE_LISTITEM_04": "Membership",
    "PROFILERAILS_PROJOBS_BTN_NAME": "ProJobs settings",
    "PROFILE_BUSINESS_CARD_BADGE_PROCOACH": "<span>Pro</span>Coach",
    "PROFILE_BUSINESS_CARD_BADGE_PROCOACH_TOOLTIP": "ProCoach member",
    "UPGRADE_HEADER_PREMFIX_NEW": "Go Premium now! <span>More info</span>",
    "UPGRADE_HEADER_PREMFIX_PROJOBS": "ProJobs. The direct route to your <span>dream job.</span>",
    "UPGRADE_MYXING_LINK_TEXT": "Premium benefits",
    "UPGRADE_MYXING_LINK_TEXT_PROJOBS": "ProJobs benefits",
    "UPGRADE_MYXING_TESTPREMIUM_ONE_DAY_TOOLTIP": "Your trial Premium Membership will expire tomorrow.",
    "UPGRADE_MYXING_TESTPREMIUM_TODAY_TOOLTIP": "Your trial Premium Membership expires today.",
    "UPGRADE_MYXING_TESTPREMIUM_TOOLTIP": "Your trial Premium Membership will expire in {.REMAINING_PREMIUM_DAYS} days.",
    "VERTICAL_NAVIGATION_BASIC": "Basic",
    "VERTICAL_NAVIGATION_EXECUTIVES": "Executive",
    "VERTICAL_NAVIGATION_FOOTER_ABOUT_XING": "About XING",
    "VERTICAL_NAVIGATION_FOOTER_BENEFITS_PLUS_MEMBERSHIP": "Benefits Plus",
    "VERTICAL_NAVIGATION_FOOTER_BLOG": "Blog",
    "VERTICAL_NAVIGATION_FOOTER_BUSINESS_PAGES": "Business Pages",
    "VERTICAL_NAVIGATION_FOOTER_COPYRIGHT_API": "&copy; {SITEOPERATOR} | All rights reserved",
    "VERTICAL_NAVIGATION_FOOTER_DATA_PROTECTION": "Privacy Policy",
    "VERTICAL_NAVIGATION_FOOTER_EXECUTIVES_MEMBERSHIP": "Executive Circles",
    "VERTICAL_NAVIGATION_FOOTER_FUTUREME": "FutureMe",
    "VERTICAL_NAVIGATION_FOOTER_INVITE_TO_XING": "Invite to XING",
    "VERTICAL_NAVIGATION_FOOTER_JOBS": "Careers at XING",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_AND_PARTNER": "Products & Solutions",
    "VERTICAL_NAVIGATION_FOOTER_MY_NETWORK": "Home",
    "VERTICAL_NAVIGATION_FOOTER_PROJECTS": "Projects",
    "VERTICAL_NAVIGATION_FOOTER_PROJOBS_UPSELL_BTN": "Go to ProJobs",
    "VERTICAL_NAVIGATION_FOOTER_SECURITY": "Security",
    "VERTICAL_NAVIGATION_FOOTER_SPIELRAUM": "Spielraum",
    "VERTICAL_NAVIGATION_FOOTER_TOP_DEALS": "Premium perks",
    "VERTICAL_NAVIGATION_FOOTER_USEFUL": "Apps & Tools",
    "VERTICAL_NAVIGATION_FOOTER_XING_SEMINARS": "XING Seminars",
    "VERTICAL_NAVIGATION_HEADER_ADD_CONTACTS": "Find new contacts",
    "VERTICAL_NAVIGATION_HEADER_BETALABS": "Beta Labs",
    "VERTICAL_NAVIGATION_HEADER_CLAIM": "For a better working life",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_BENEFITS_PLUS_MEMBERSHIP": "Benefits Plus",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_DASHBOARD": "ProJobs",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SALES": "Sales status overview",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS_INVOICES": "Settings/Invoices & Accounts",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_BENEFITSPLUS": "Benefits Plus - <span>Positively beneficial</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_EVENTS_BLOCKBUSTER": "Premium Event Blockbusters that help you <span>get ahead.</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_EXECUTIVES": "Gain Executive status now! <span>More</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_NEW": "Go Premium now! <span>More info</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROBUSINESS": "ProBusiness – <span>Your smart network assistant.</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROCOACH": "ProCoach – <span>Guiding you to more success</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROJOBS": "ProJobs. The direct route to your <span>dream job.</span>",
    "VERTICAL_NAVIGATION_HEADER_PREMFIX_PROTRAINER": "ProTrainer – <span>Guiding you to more success</span>",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ADVANCED": "Advanced Search",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ADVANCED_DESCRIPTION": "What are you looking for?",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES": "Companies",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_CONTENT_PAGES": "News",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_FOR": "All results for",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_PREMIUM_FLAG": "PREMIUM",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_QUERY_SUGGESTIONS_JOBS": "All {keywords} jobs",
    "VERTICAL_NAVIGATION_HEADER_SLOGAN": "XING – For a better working life",
    "VERTICAL_NAVIGATION_JOBS": "Jobs",
    "VERTICAL_NAVIGATION_MYPROEXECUTIVES": "Executive",
    "VERTICAL_NAVIGATION_MY_PROJOBS": "ProJobs",
    "VERTICAL_NAVIGATION_MY_PROJOBS_SETTINGS": "Settings",
    "VERTICAL_NAVIGATION_NEW": "NEW",
    "VERTICAL_NAVIGATION_PREMIUM": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_ARAG_SUBLINE": "NEW: XING Arbeitsrechtsschutz",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_ARAG_TOOLTIP": "XING Arbeitsrechtsschutz",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SUBLINE": "Go Premium now!",
    "VERTICAL_NAVIGATION_PREMIUM_HUB": "Premium",
    "VERTICAL_NAVIGATION_PROCOACH": "<span>Pro</span>Coach",
    "VERTICAL_NAVIGATION_PROFILE": "Profile",
    "VERTICAL_NAVIGATION_PROJECTS": "Projects",
    "WELCOME_BOX_LINK_PROFILE": "Profile",
    "XE_404_FIRST_P": "Feel free to give our <a href=\"/help/\">Help Centre</a> a try as it's home to a lot of useful information about XING.",
    "XE_404_H_1": "Sorry, the page you requested isn't available.",
    "XE_404_SEARCHTEXT_LOGGED_IN": "Why not try searching for your friends, colleagues and business partners instead?",
    "XE_404_SEARCHTEXT_LOGGED_OUT": "Why not try searching for your friends, colleagues and business partners instead?",
    "XE_404_TITLE": "Unknown page (404 error)",
    "XE_CALENDAR_BACK_LINK": "previous",
    "XE_CALENDAR_NEXT_LINK": "next",
    "XE_CALENDAR_SELECTION": "selection",
    "XE_CALENDAR_TODAY": "today",
    "XE_CLOSE_LINK": "Close",
    "XE_NEW": "NEW",
    "XE_NOT_A_XING_MEMBER_YET": "Not joined XING yet?",
    "XE_PAGER_BACK": "Back",
    "XE_PAGER_NEXT": "Next",
    "XE_SIGN_UP_FOR_FREE": "Sign up now for free!",
    "XING_SLOGAN": "XING – For a better working life",
    "X_UI_BUTTON_FIND": "Search",
    "X_UI_FOOTER_COPYRIGHT_API": "&copy; {-SITEOPERATOR} | All rights reserved",
    "X_UI_HEADER_ADVANCED_SEARCH": "Advanced Search",
    "X_UI_HEADER_ADVANCED_SEARCH2": "Advanced Search",
    "X_UI_HEADER_DOWNLOAD": "Downloads",
    "X_UI_HEADER_HELP": "Help & Contact",
    "X_UI_HEADER_INVITELINK": "Invite people to join XING",
    "X_UI_HEADER_LOGOUT": "Log out",
    "X_UI_HEADER_SEARCH_HINT": "Name, company or search term",
    "X_UI_HEADER_XING_SHARE": "XING share button",
    "X_UI_NAVIGATION_ADDRESSBOOK": "Contacts",
    "X_UI_NAVIGATION_ADMASTER": "Manage ads",
    "X_UI_NAVIGATION_BOOKMARK": "Bookmarks",
    "X_UI_NAVIGATION_COMPANIES": "Companies",
    "X_UI_NAVIGATION_COMPANIES_SUB_BEST_OFFERS": "Premium perks",
    "X_UI_NAVIGATION_COMPANIES_SUB_CREATE": "Create Company Profile",
    "X_UI_NAVIGATION_COMPANIES_SUB_MY_COMPANIES": "Your companies",
    "X_UI_NAVIGATION_COMPANIES_SUB_OVERVIEW": "Overview",
    "X_UI_NAVIGATION_CONTENT": "News",
    "X_UI_NAVIGATION_CONTENT_BOOKMARKS": "Bookmarks",
    "X_UI_NAVIGATION_CONTENT_OVERVIEW": "Industry News",
    "X_UI_NAVIGATION_CONTENT_PAGES": "News pages",
    "X_UI_NAVIGATION_EVENTS": "Events",
    "X_UI_NAVIGATION_EVENTS2": "Events",
    "X_UI_NAVIGATION_EVENTS2_SUB_MY": "Your events",
    "X_UI_NAVIGATION_EVENTS2_SUB_NEW": "Create event",
    "X_UI_NAVIGATION_EXPAND_NETWORK": "Expand network",
    "X_UI_NAVIGATION_FIND_EVENTS": "Overview",
    "X_UI_NAVIGATION_GROUPS": "Groups",
    "X_UI_NAVIGATION_JOBS": "Jobs",
    "X_UI_NAVIGATION_LOGIN_ERROR_CONNECTION": "Your login failed due to connection problems. Give it another try!",
    "X_UI_NAVIGATION_LOGIN_ERROR_INVALID": "Please check your login details and try again.",
    "X_UI_NAVIGATION_MARKETPLACE_MANAGE": "Manage job ads",
    "X_UI_NAVIGATION_MARKETPLACE_NEWPOSTING": "Post new job ad",
    "X_UI_NAVIGATION_MARKETPLACE_OVERVIEW": "Jobs overview",
    "X_UI_NAVIGATION_MY_MESSAGES": "Messages",
    "X_UI_NAVIGATION_MY_NETWORK": "Home",
    "X_UI_NAVIGATION_PROJECTS": "Projects",
    "X_UI_NAVIGATION_RECRUITER_ACCOUNT": "Candidate overview",
    "X_UI_NAVIGATION_SALES_ACCOUNT": "Sales status overview",
    "X_UI_NAVIGATION_TALENT_MANAGER": "TalentManager",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_0": "Your password is really easy to guess.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_1": "Your password is really easy to guess.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_2": "Your password is quite easy to guess.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_3": "Add a few more characters just to be on the safe side.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_4": "That's a decent password.",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_5": "This is a great password!",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_6": "Passwords don't get much better than this!",
    "ACCOUNT_FORMS_PASSWORD_STRENGTH_LESS_THAN": "Please make sure your password contains at least 8 characters.",
    "ERROR_REGISTER_EMAIL_REG": "We already know this e-mail address. Perhaps you already registered? If so, just log in now.",
    "ERROR_REGISTER_EMAIL_SECONDARY": "Please check the information below about this e-mail address.",
    "LOGIN_INVALID_PASSWORD": "Please check your login details and try again.",
    "LOGIN_NEW_REGISTER_TEXT": "Not joined XING yet? Register now free of charge",
    "LOGIN_OAUTH_INFO_PARAGRAPH": "Please sign in with your XING login details to grant {application} access to your XING data.",
    "WELCOME_APP_MINIREG_DISALLOWED_DOMAIN": "Your e-mail address seems to be incorrect. Maybe there's a typo?",
    "WELCOME_APP_MINIREG_ERROR_BLACKLIST_LICENSE_COMPANY_MATCH": "Would you like to showcase your company on XING? That's great: Go ahead and <a href=\"https://recruiting.xing.com/e-recruiting-loesungen/employerbranding?sc_o=welcome_signup_error_companies_suggestion\" target=\"_blank\">create a XING Page for your company</a>.",
    "WELCOME_APP_MINIREG_ERROR_BLACKLIST_LICENSE_MATCH": "Unfortunately you can't sign up with the details you've entered. If you have questions about this, feel free to <a href=\"https://www.xing.com/support/contact/registration/confirm_registration\">get in touch</a>.",
    "WELCOME_APP_MINIREG_ERROR_EMAIL": "Please check the e-mail address you entered.",
    "WELCOME_APP_MINIREG_ERROR_FIRST_NAME": "Please enter your first name here.",
    "WELCOME_APP_MINIREG_ERROR_LAST_NAME": "Please enter your last name here.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL": "For your own security you should choose a password different to your e-mail address.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_FIRST_NAME": "For your own security you should choose a password different to your first name.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME": "For your own security you should choose a password different to your last name.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG": "Please choose a password containing no more than 1,024 characters.",
    "WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_SHORT": "Please select a password (min. 8 characters).",
    "WELCOME_APP_MINIREG_ERROR_PHONE": "Please check your phone number.",
    "WELCOME_APP_MINIREG_ERROR_TANDC": "Please confirm that you accept the Terms & Conditions and the Privacy Policy.",
    "WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR": "Please enter your e-mail address here.",
    "WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR": "Please enter your first name here.",
    "WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR": "Please enter your last name here.",
    "WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR": "Please enter your password here.",
    "WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR": "Please enter your password here.",
    "WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL": "Remember me",
    "WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR": "Sorry, something went wrong. Please try again.",
    "WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR": "Please enter your e-mail address.",
    "WELCOME_LOGIN_HEADLINE": "Welcome back!",
    "WELCOME_LOGIN_PASSWORD_LABEL": "Password",
    "WELCOME_LOGIN_PROBLEMS_LOGGING_IN": "Having problems logging in?",
    "WELCOME_LOGIN_SUBMIT_LABEL": "Log in",
    "WELCOME_LOGIN_USERNAME_LABEL": "E-mail",
    "WELCOME_REGISTRATION_DATAPROTECTION_LABEL": "Privacy Policy",
    "WELCOME_REGISTRATION_DATAPROTECTION_LINK": "https://privacy.xing.com/en/privacy-policy",
    "WELCOME_REGISTRATION_EMAIL_LABEL": "E-mail",
    "WELCOME_REGISTRATION_FIRSTNAME_LABEL": "First name",
    "WELCOME_REGISTRATION_HEADLINE": "Get your free XING profile now:",
    "WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL": "Yes, {email} is the right e-mail address.",
    "WELCOME_REGISTRATION_LASTNAME_LABEL": "Last name",
    "WELCOME_REGISTRATION_PASSWORD_LABEL": "Password",
    "WELCOME_REGISTRATION_RECAPTCHA_HEADLINE": "Nearly done!",
    "WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH": "We need to make sure you're a real person to protect you and others from spam.",
    "WELCOME_REGISTRATION_SECONDARY_EMAIL_ERROR": "This e-mail address is already in use with a different account. Do you really want to register as a new member?",
    "WELCOME_REGISTRATION_SKIP_SECONDARY_EMAIL_CHECK": "Yes, I'd like to register as a new member using the e-mail address {email}",
    "WELCOME_REGISTRATION_SOFT_EMAIL_ERROR": "Please check your e-mail address again.",
    "WELCOME_REGISTRATION_SUBMIT_LABEL": "Continue",
    "WELCOME_REGISTRATION_TANDC_DESCRIPTION": "I accept XING's {tandc} and acknowledge the {dataprotection}.",
    "WELCOME_REGISTRATION_TANDC_LABEL": "GTC",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON": "Press and hold me for 5 seconds",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR": "That didn't work. Please press and hold the button again for 5 seconds.",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE": "One last thing",
    "WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH": "To make sure you're a real person and not a bot, please press and hold the button below for 5 seconds.",
    "WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL": "Your file is either too big or in an unsupported format. We recommend PDF files.",
    "WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL": "Upload CV",
    "WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL": "That didn't work. Please try again.",
    "WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT": "Submit your CV now and we will provide you with personalized job recommendations.",
    "WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS": "We've added your CV details to your XING profile. {br}{br} Please make sure everything is okay and add any information that's missing.",
    "WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL": "Supported formats: PDF, Word (DOCX) or Pages (max. 100 MB)",
    "WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT": "Let recruiters come to you",
    "WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS": "Your CV",
    "WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR": "Sorry, something  went wrong. Please try again.",
    "WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR": "Sorry, something  went wrong. Please try again.",
    "ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE": "Why am I seeing this ad?",
    "ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA": "Learn more",
    "ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE": "about targeting criteria.",
    "ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE": "You're seeing this ad because you meet at least one of the advertiser's targeting criteria.",
    "DISCO_OBJECTS_EVENT_GUEST_LIST": "Guest list",
    "DISCO_OBJECTS_FOLLOWER.one": "follower",
    "DISCO_OBJECTS_FOLLOWER.other": "followers",
    "DISCO_OBJECTS_FOLLOWER.zero": "followers",
    "EV_205_LINKED_EVENTS_MORE_OCCURRENCES": "more dates",
    "NATIVE_ADS_DOT_MENU_REPORT_OBJECT": "Report this ad",
    "NATIVE_ADS_FOLLOWER": "follower",
    "NATIVE_ADS_FOLLOWERS": "followers",
    "NATIVE_ADS_LEARN_MORE_BUTTON": "Learn more",
    "NATIVE_ADS_RECOMMENDS_LABEL": "recommends",
    "NATIVE_ADS_SPONSORED_LABEL": "Sponsored",
    "NATIVE_ADS_VIEW_EVENT_BUTTON": "View event details",
    "CAREER_GUIDANCE_DETAILS_PAGE_MODERN_1": "Do you like solving tasks on your own without any constraints? You'll feel right at home in a modern corporate culture.",
    "CAREER_GUIDANCE_DETAILS_PAGE_TRADITIONAL_1": "A more traditional corporate culture typically has clearly defined rules and structures to ensure stability and performance.",
    "ERROR_SORRY_TITLE": "Sorry...",
    "JOB_DETAILS_HR_TITLE": "Your contact person",
    "JOB_POSTING_APPLY_EXTERNAL_URL": "Visit employer website",
    "JOB_POSTING_APPLY_EXTERNAL_URL_ABACUS_189_VARIANT_B": "Visit employer website",
    "JOB_POSTING_APPLY_EXTERNAL_URL_ABACUS_189_VARIANT_C": "Start application",
    "JOB_POSTING_XING_APPLY_BUTTON_ABACUS_183_VARIANT_B": "Apply with XING profile",
    "JOB_SEARCH_PROJOBS_UPSELL_CTA": "Upgrade now",
    "JOB_SEARCH_PROJOBS_UPSELL_HEADLINE": "Let the jobs come to you with ProJobs!",
    "JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_BASIC_MESSAGES_FACTOR": "10×",
    "JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_BASIC_VISITS_FACTOR": "15×",
    "JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_MESSAGES_FACTOR": "2×",
    "JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_MESSAGES_TEXT": "more messages",
    "JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_VISITS_FACTOR": "2.5×",
    "JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_VISITS_TEXT": "more visits",
    "JOB_SEARCH_RADIUS_FILTER_DESCRIPTION_DEFAULT": "Only in {city}",
    "JOB_SEARCH_RADIUS_FILTER_DESCRIPTION_VALUE": "Within {value} km of {city}",
    "JOBS_DETAIL_AI_SUMMARY_FEEDBACK": "Helpful?",
    "JOBS_DETAIL_AI_SUMMARY_HEADER": "View job summary",
    "JOBS_DETAIL_AI_SUMMARY_KEY_RESPONSIBILITIES_SECTION_HEADER": "Required duties",
    "JOBS_DETAIL_AI_SUMMARY_NOTICE": "This is an AI-generated summary",
    "JOBS_DETAIL_AI_SUMMARY_QUALIFICATIONS_SECTION_HEADER": "Required skills",
    "JOBS_DETAIL_INSTANT_APPLY_PROFILE_REASSURANCE_BUTTON": "Apply with profile",
    "JOBS_DETAIL_PREFERRED_APPLY_DESCRIPTION": "This employer would prefer you to apply with your XING profile.",
    "JOBS_DETAIL_PREFERRED_APPLY_HEADLINE": "Apply with XING profile preferred",
    "JOBS_FEEDBACK_MODULE_ANSWER_DISSATISFIED": "Bad",
    "JOBS_FEEDBACK_MODULE_ANSWER_SATISFIED": "Good",
    "JOBS_FEEDBACK_MODULE_ANSWER_SOMEWHAT": "Okay",
    "JOBS_FEEDBACK_MODULE_DESCRIPTION": "Your feedback will help us improve it further.",
    "JOBS_FEEDBACK_MODULE_THANKS_MESSAGE": "Thanks for your feedback!",
    "JOBS_FEEDBACK_MODULE_TITLE": "Rate this page layout",
    "JOBS_FIND_JOBS_HEADER_TITLE": "Find the right job for you.",
    "JOBS_HYBRID_TAG": "Hybrid",
    "JOBS_INSTANT_APPLY_CREATE_PROFILE_CONSENT_WITH_CV_DATA": "I accept that XING will create a profile with my CV data for faster applications.",
    "JOBS_INSTANT_APPLY_DOCUMENT_LINK_TEXT": "Document",
    "JOBS_INSTANT_APPLY_ENTER_CV_CURRENT_DATE": "Present",
    "JOBS_INSTANT_APPLY_ENTER_CV_DATE_PLACEHOLDER": "Year",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_DEGREE_FIELD": "Degree or diploma",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_DEGREE_FIELD_EMPTY_ERROR": "Please enter your degree or diploma",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_END_DATE_ERROR": "Please enter a year. If you still study there, select 'Present'",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_SCHOOL_FIELD": "School or university",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_SCHOOL_FIELD_EMPTY_ERROR": "Please enter your school or university",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_TITLE": "Highest academic qualification",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_YEAR_END_LABEL": "end year of education",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_YEAR_PRESENT_CHECK_LABEL": "present education",
    "JOBS_INSTANT_APPLY_ENTER_CV_EDUCATION_YEAR_START_LABEL": "start year of education",
    "JOBS_INSTANT_APPLY_ENTER_CV_END_DATE_ERROR": "Please enter a year. If you still work there, select 'Present'",
    "JOBS_INSTANT_APPLY_ENTER_CV_END_DATE_LABEL": "To",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_FIELD_EMPTY_ERROR": "Please select your years of experience",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_FIELD_LABEL": "Years of experience",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_FIELD_OPTION_1": "No experience",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_FIELD_OPTION_2": "1-2 years",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_FIELD_OPTION_3": "3-5 years",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_FIELD_OPTION_4": "5+ years",
    "JOBS_INSTANT_APPLY_ENTER_CV_EXPERIENCE_HEADLINE": "Professional background",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_COMPANY_FIELD": "Company name",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_COMPANY_FIELD_EMPTY_ERROR": "Please enter your company name",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_END_DATE_ERROR": "Please enter a year. If you still work there, select 'Present'",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_FIELD": "Job title",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_FIELD_EMPTY_ERROR": "Please enter your job title",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_TITLE": "Your latest or most relevant job",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_YEAR_END_LABEL": "end year of job",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_YEAR_PRESENT_CHECK_LABEL": "Present job",
    "JOBS_INSTANT_APPLY_ENTER_CV_LAST_JOB_YEAR_START_LABEL": "Start year of job",
    "JOBS_INSTANT_APPLY_ENTER_CV_MODE_FIELD_ENTER_MANUALLY_VALUE": "Enter manually",
    "JOBS_INSTANT_APPLY_ENTER_CV_MODE_FIELD_UPLOAD_VALUE": "Upload CV",
    "JOBS_INSTANT_APPLY_ENTER_CV_START_DATE_ERROR": "Please enter the year",
    "JOBS_INSTANT_APPLY_ENTER_CV_START_DATE_LABEL": "From",
    "JOBS_INSTANT_APPLY_FORM_ADDITIONAL_COMMENTS_BODY": "Feel free to add any comments below.",
    "JOBS_INSTANT_APPLY_FORM_ADDITIONAL_COMMENTS_HEADLINE": "Additional comments (optional)",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_BODY": "You'll receive an e-mail confirming your application soon.",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_BACK_BUTTON": "Back to Jobs",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_BODY": "You'll receive an e-mail to <span>{email}</span> confirming your application. Good luck!",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_CTA": "Update profile with CV",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_CTA_ERROR": "Something went wrong. Please try again later.",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_HEADLINE": "Application submitted",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_SUB_BODY": "Update your profile with the professional experience and skills from your CV. Adding these details will get you found by over 20,000 recruiters.",
    "JOBS_INSTANT_APPLY_FORM_CONFIRMATION_UPDATE_PROFILE_SUB_HEADLINE": "You're just 2 clicks away from updating your profile",
    "JOBS_INSTANT_APPLY_FORM_CONTACT_DETAILS_HEADLINE": "Your contact details",
    "JOBS_INSTANT_APPLY_FORM_PHONE_FIELD_EMPTY_ERROR": "Please enter a phone number",
    "JOBS_INSTANT_APPLY_FORM_PHONE_FIELD_INVALID_ERROR": "Please check your phone number again",
    "JOBS_INSTANT_APPLY_FORM_PHONE_NUMBER_LABEL": "Phone number",
    "JOBS_INSTANT_APPLY_FORM_PHONE_NUMBER_OPTIONAL_LABEL": "Phone number (optional)",
    "JOBS_INSTANT_APPLY_FORM_PROFILE_INFO_HEADLINE": "Preview of your profile",
    "JOBS_INSTANT_APPLY_PRIVACY_LINK_TEXT": "Privacy Policy",
    "JOBS_INSTANT_APPLY_PROFILE_BACK_TO_JOBS": "Back to Jobs",
    "JOBS_INSTANT_APPLY_PROFILE_BANNER_TITLE": "How XING can help you with your job search:",
    "JOBS_INSTANT_APPLY_PROFILE_CONFIRMED_ACCOUNT_TEXT": "<a>Log in with your e-mail and password</a> to apply with your profile.",
    "JOBS_INSTANT_APPLY_PROFILE_CONFIRMED_ACCOUNT_TITLE": "You already have a XING profile",
    "JOBS_INSTANT_APPLY_PROFILE_CREATED_BY_XING_TEXT": "You’ll receive an an e-mail with a link to activate your registration. Confirm your e-mail to apply faster with your profile next time!",
    "JOBS_INSTANT_APPLY_PROFILE_CREATED_BY_XING_TITLE": "We've created a XING profile for you",
    "JOBS_INSTANT_APPLY_PROFILE_ERROR_BUTTON_REGISTER": "Create profile",
    "JOBS_INSTANT_APPLY_PROFILE_ERROR_TEXT": "To apply for jobs with a XING profile in the future, you can <a>create one now</a>.",
    "JOBS_INSTANT_APPLY_PROFILE_ERROR_TITLE": "We couldn't create a profile for you",
    "JOBS_INSTANT_APPLY_PROFILE_LO_CONFIRMATION_BODY": "You'll receive an e-mail to <strong>{applicationEmailValue}</strong> confirming your application. Good luck!",
    "JOBS_INSTANT_APPLY_PROFILE_RESEND_CONFIRMATION_EMAIL_TEXT": "Not received an e-mail yet? <a>Send again</a>",
    "JOBS_INSTANT_APPLY_PROFILE_UNCONFIRMED_ACCOUNT_TEXT": "Confirm your registration by clicking on the link in the e-mail we sent you. Then you can save time by using your XING profile when applying for vacancies.",
    "JOBS_INSTANT_APPLY_PROFILE_UNCONFIRMED_ACCOUNT_TITLE": "You're one step away from your XING profile",
    "JOBS_INSTANT_APPLY_TERMS_LINK_TEXT_WEB": "Terms & Conditions",
    "JOBS_INSTANT_APPLY_UPLOAD_BODY": "Upload your CV",
    "JOBS_INSTANT_APPLY_UPLOAD_CV_BUTTON": "Upload CV",
    "JOBS_INSTANT_APPLY_UPLOAD_HINT_FILES": "Upload your CV and up to two other files (e.g. a cover letter or referrals).",
    "JOBS_INSTANT_APPLY_UPLOAD_HINT_FORMAT": "Files can be up to 5 MB in size and in any of the following formats: TXT, DOC, DOCX, PDF, JPG, PNG, ODT, RTF",
    "JOBS_INSTANT_APPLY_UPLOAD_OTHER_BUTTON": "Add more documents (optional)",
    "JOBS_INSTANT_XING_APPLY_FLAG": "Apply without documents",
    "JOBS_JOB_DETAIL_KUNUNU_BENEFITS": "Employee benefits",
    "JOBS_JOB_DETAIL_KUNUNU_BENEFITS_SHOW_LESS": "Show fewer benefits",
    "JOBS_JOB_DETAIL_KUNUNU_TITLE": "Employer reviews",
    "JOBS_JOB_DETAILS_KUNUNU_BENEFITS_SHOW_ALL": "View all benefits",
    "JOBS_JOB_DETAILS_KUNUNU_CULTURE": "Show more",
    "JOBS_JOB_DETAILS_XING_VERIFIED": "Verified job ad",
    "JOBS_JOBBOX_DELETE_JOB": "Remove",
    "JOBS_LANDING_LO_HERO_MARKETING_CAMPAIGN_2023": "Over 1 million jobs",
    "JOBS_ONE_CLICK_APPLY_FEEDBACK_BUTTON_NEGATIVE": "No",
    "JOBS_ONE_CLICK_APPLY_FEEDBACK_BUTTON_NEUTRAL": "Okay",
    "JOBS_ONE_CLICK_APPLY_FEEDBACK_BUTTON_POSITIVE": "Yes",
    "JOBS_ONE_CLICK_APPLY_FEEDBACK_HEADLINE": "Did you like this feature?",
    "JOBS_ONE_CLICK_APPLY_FEEDBACK_SUB_HEADLINE": "Help us make XING even better for you",
    "JOBS_ONE_CLICK_APPLY_PRIMARY_CTA_VARIANT_B": "I’m interested",
    "JOBS_ONE_CLICK_APPLY_PRIMARY_CTA_VARIANT_C": "One-click apply",
    "JOBS_ONE_CLICK_APPLY_SECONDARY_CTA": "Apply with documents",
    "JOBS_POSTING_ACTIVELY_RECRUITING_MARKER": "Actively recruiting",
    "JOBS_POSTING_EARLY_APPLICANT_MARKER": "Be an early applicant",
    "JOBS_POSTING_LAST_CHANCE_MARKER": "Last chance to apply",
    "JOBS_POSTING_XING_APPLY_INFO_SENDER_EMAIL_ADDRESS": "We'll send your application to {replyEmail}.",
    "JOBS_REMOTE_AVAILABLE_TAG": "Remote likely",
    "JOBS_REMOTE_TAG": "Remote",
    "JOBS_SEARCH_ALERTS_CREATE_ERROR_CTA": "OK",
    "JOBS_SEARCH_ALERTS_CREATE_ERROR_HEADLINE": "To create a search alert, please enter a job title and city first.",
    "JOBS_SEARCH_ALERTS_CREATE_ERROR_TEXT": "Then you can go ahead and create a search alert.",
    "JOBS_SEARCH_COMPANY_CULTURE_FILTER_VALUE": "Culture match",
    "JOBS_SEARCH_EDIT_ALERT_BANNER_SAVE_BUTTON": "Save",
    "JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT": "Save changes",
    "JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT_DESKTOP_CITY": "Save changes to search alert in <b>{city}</b>",
    "JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT_DESKTOP_KEYWORDS": "Save changes to search alert for <b>{position}</b>",
    "JOBS_SEARCH_EDIT_ALERT_BANNER_TEXT_DESKTOP_KEYWORDS_CITY": "Save changes to search alert for <b>{position}</b> in <b>{city}</b>",
    "JOBS_SEARCH_EDIT_ALERT_SAVE_BUTTON": "Save changes",
    "JOBS_SEARCH_EMPTY_ERROR_HEADLINE": "Please enter a job title or location",
    "JOBS_SEARCH_EMPTY_ERROR_TEXT": "Matches will be shown based on your entries.",
    "JOBS_SEARCH_FILTER_EMPLOYEE_PERKS": "Employee perks",
    "JOBS_SEARCH_FILTER_WORKING_ATMOSPHERE": "Workplace culture",
    "JOBS_SEARCH_RESET_FILTERS_BUTTON": "Reset filters",
    "KUNUNU_BENEFITS_SHOW_ALL": "View all benefits"
  }
}